<template>
    <div>

        <div v-if="showPreviewImage" @click.self="showPreviewImage = false;" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
            <div class="bg-white rounded-lg mx-6">

                <div class="">

                    <v-btn
                        class="float-right -mt-3 -mr-3"
                        fab
                        color="gray"
                        dark
                        x-small
                        elevation="0"
                        @click="showPreviewImage = false"
                        :ripple="false"
                        >
                        <v-icon >
                            mdi-close
                        </v-icon>
                    </v-btn>

                    <div class="text-center">
                        <img :src="previewImageUrl" style="max-height: 700px;" />
                    </div>

                </div>

            </div>
        </div>

        <div v-if="showDetails" @click.self="showDetails = false;" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2); max-width: 100$;">
            <div class="bg-white rounded-lg mx-3" style="width: 100%; height: 100%">

                <div class="" style="height: 98%; overflow: auto;">

                    <v-btn
                        class="float-right -mt-3 -mr-3"
                        fab
                        color="gray"
                        dark
                        x-small
                        elevation="0"
                        @click="showDetails = false"
                        :ripple="false"
                        >
                        <v-icon >
                            mdi-close
                        </v-icon>
                    </v-btn>

                    <div class="p-2 pb-5">
                        <div class="text-lg pt-3 pl-2"><strong>Search Results</strong></div>

                        <table class="w-full rg-datatable mt-5">
                            <thead class="border-b border-gray-100 w-full">
                            <tr>
                                <th>Business Name</th>
                                <th>Rating</th>
                                <th>{{ ((search.keyword.toLowerCase().indexOf('law') != -1 || search.keyword.toLowerCase().indexOf('attorney') != -1 || search.keyword.toLowerCase().indexOf('real extate') != -1) ? 'Google Verified' : 'Google Verified') }}</th>
                                <th>Years in business</th>
                                <th>Position</th>
                                <th>&nbsp;</th>
                            </tr>
                            </thead>
                            <tbody class="w-full" style="">
                                <tr v-for="(item, index) in detailsSearch.results" :key="index">
                                    <td>{{ unEntity(item.name) }}</td>
                                    <td>{{ item.rating }}</td>
                                    <td>{{ ((item.google_verified) ? "Yes": "No") }}</td>
                                    <td>{{ item.years_in_business }}</td>
                                    <td>{{ item.position }}</td>
                                    <td>
                                        <a :href="item.profile_url" target="lsa-search-results-details-link">Link</a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>

            </div>
        </div>
        
    <div class="dashboard-box stats-box w-full px-2 mb-5">
            <v-card class="pa-2" tile>
                  <div :class="(($vuetify.breakpoint.xs) ? 'p-1' : 'p-3')">
                    <div class="flex flex-row flex-wrap">
                      <div class="w-full lg:w-2/3" style="position: relative;">
                        <!-- Business Name -->
                        <strong class="mt-2 text-lg">{{ search.properties.business.name }}</strong>

                        <!-- Google Verified Badge -->
                        <div style="display: inline-block; height: 30px; width: 140px; margin: auto; padding-top: 13px; margin-left: 15px;">
                          <div v-if="search.properties.business.google_verified" style="float: left; padding-right: 5px;">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <circle cx="8" cy="8" r="8" fill="#54AC0E"/>
                              <path d="M4.5 8L7 10.5L11.5 5.5" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </div>
                          <div v-if="search.properties.business.google_verified" style="float: left; font-size: 12px; font-weight: bold; color: #54AC0E;">
                            Google Verified
                          </div>
                          <div v-if="search.properties.business.google_verified" style="clear: both;"></div>
                        </div>

                        <!-- Website -->
                        <div v-if="getBusinessWebsite" class="website mt-1 text-sm">
                          <a :href="getBusinessWebsite" target="lr-website-link" style="color: #4EC5A1 !important;">
                            {{ getBusinessWebsite }}
                          </a>
                        </div>

                        <div class="clearfix pt-4"></div>

                        <!-- Address & Phone Row -->
                        <div class="flex flex-row flex-wrap">
                          <div class="w-full lg:w-1/2" style="position: relative;">
                            <div class="mb-2" style="color: #757B89; font-size: 11px;">Address</div>
                            {{ getFormattedAddress }}
                          </div>

                          <div class="w-full lg:w-1/2" style="position: relative;">
                            <div class="mb-2" style="color: #757B89; font-size: 11px;">Phone</div>
                            {{ getFormattedPhone }}
                          </div>

                          <div class="w-full lg:w-1/2 pt-5" style="position: relative;">
                            <div class="mb-2" style="color: #757B89; font-size: 11px;">Keyword</div>
                            {{ search.keyword }}
                          </div>

                          <div class="w-full lg:w-1/2 pt-5" style="position: relative;">
                            <div class="mb-2" style="color: #757B89; font-size: 11px;">Serving Area</div>
                            {{ getServingArea }}
                          </div>
                        </div>

                        <div class="clearfix"></div>

                        <div v-if="!search.properties.success" style="font-size: 12px; padding-top: 15px;">
                          <i class="mdi mdi-reload fa-spin"></i> Please wait, we are gathering the data for the Audit. The report should be ready around 10 AM PST.
                        </div>
                      </div>

                      <!-- LSA Photo -->
                      <div class="lr-seo-audit-photo w-full lg:w-1/3">
                        <div v-if="search.properties.business.lsa_photo">
                          <img :src="search.properties.business.lsa_photo" style="height: 200px; object-fit: contain;" />
                        </div>
                      </div>
                    </div>

                    <br clear="all" />
                    <hr />
                  </div>
                </v-card>
        </div>



        <div v-show="lsa_tab == 0 || $vuetify.breakpoint.xs || true">
            <div v-if="search.properties.summary.grade">
                <div class="dashboard-box stats-box w-full px-2 mb-5 mt-3">
                        <v-card
                            class="pa-2 pt-6 pb-6"
                            tile
                        >
                        <div class="flex flex-row flex-wrap">
                            <div class="w-full lg:w-1/2" style="position: relative;">
                            <div class="lr-seo-box-left">
                                <div class="lr-doughnut-wrapper">
                                <div class="lr-doughnut-title">
                                    {{ search.properties.summary.grade.value }}
                                </div>
                                    <apexchart type="donut" :options="summaryDoughnut.chartOptions" :series="summaryDoughnut.series" width="200"></apexchart>
                                </div>
                            </div>

                            <div class="lr-seo-box-right pt-4">
                                <div class="" style="font-size: 20px; font-weight: bold;">
                                    {{ search.properties.summary.grade.title }}
                                </div>

                                <div style="color: #757B89; font-size: 12px;">
                                    {{ search.properties.summary.grade.description }}
                                </div>
                            </div>

                            <div class="clearfix"></div>
                            </div>
                        </div>
                    </v-card>
                </div>
            </div>

            <div class="" style="font-size: 12px;">
                <div class="pt-3" v-if="search.properties.competitors.list && search.properties.competitors.list.length > 0">
                    <div class="flex flex-row flex-wrap">
                        <div v-for="(competitor, index) in search.properties.competitors.list" :key="index" class="w-full lg:w-1/4" style="position: relative;">
                            <div class="dashboard-box stats-box w-full px-2 mb-5">
                                <v-card
                                    class="pa-2 pt-6 pb-6"
                                    tile
                                    :style="((competitor.my_business) ? 'background: #4EC5A1;' : '')"
                                >
                                    <div style="width: 100px; color: #FFFFFF;  text-align: center; padding: 5px; font-weight: bold; margin: auto; background: #4EC5A1; border-radius: 23px;"
                                        :style="((competitor.my_business) ? 'background: #FFFFFF; color: #4EC5A1' : '')"
                                    >Rank #{{ competitor.rank }}</div>

                                    <div v-if="!competitor.profile_url" style="text-align: center; font-weight: bold; padding: 15px; padding-bottom: 5px; font-size: 14px;">
                                        <span target="lr-competitor" :style="((competitor.my_business) ? 'color: #FFFFFF !important;' : '')">{{ displayCompetitorName(competitor.name) }}</span>
                                    </div>

                                    <div v-else style="text-align: center; color: #313E42; font-weight: bold; padding: 15px; padding-bottom: 5px; font-size: 14px;"
                                    
                                    ><a :href="competitor.profile_url" target="lr-competitor" :style="((competitor.my_business) ? 'color: #FFFFFF !important;' : '')">{{ displayCompetitorName(competitor.name) }}</a></div>

                                    <div :style="((competitor.my_business) ? 'color: #FFFFFF !important;' : '')">
                                        <div style="height: 30px; width: 140px; margin: auto; padding-top: 10px;">
                                            <div v-if="competitor.google_verified" style="float: left; padding-right: 5px;">
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                <rect width="16" height="16" fill="url(#pattern0)"/>
                                                <defs>
                                                <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
                                                <use xlink:href="#image0_788_26396" transform="scale(0.00333333)"/>
                                                </pattern>
                                                <image id="image0_788_26396" width="300" height="300" xlink:href="data:image/png;base64,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"/>
                                                </defs>
                                                </svg>
                                            </div>
                                            <div v-if="competitor.google_verified" style="float: left;">
                                                {{ ((search.keyword.toLowerCase().indexOf('law') != -1 || search.keyword.toLowerCase().indexOf('attorney') != -1 || search.keyword.toLowerCase().indexOf('real extate') != -1) ? 'Google Verified' : 'Google Verified') }}
                                            </div>
                                            <div v-if="competitor.google_verified" style="clear: both;"></div>
                                        </div>

                                        <div class="" v-if="competitor.my_business && competitor.rank == '20+'">
                                            <div class="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mt-6" role="alert">
                                                <div><strong>Not Found!</strong> Currently we're not able to find your LSA account within the search provided. Contact your account manager to improve your visibility and make sure your stand out next to your competitors</div>
                                            </div>
                                        </div>

                                        <div v-else>

                                            <div style="padding-bottom: 14px; padding-left: 10px; padding-right: 10px; padding-top: 20px;" :style="((competitor.my_business) ? 'border-bottom: 1px solid rgba(255, 255, 255, 0.05);' : 'border-bottom: 1px solid rgba(0, 0, 0, 0.05);')">
                                                <div style="float: left; padding-right: 5px;">
                                                    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M1.99885 0.398438C1.06282 0.398438 0.300781 1.16102 0.300781 2.09705V12.5144C0.300781 13.4505 1.06285 14.213 1.99885 14.213H7.16571L8.72718 17.6233C8.7758 17.7305 8.88267 17.7995 9.00053 17.7995C9.11839 17.7995 9.22526 17.7305 9.27388 17.6233L10.8354 14.213H16.0015C16.9376 14.213 17.7001 13.4505 17.7001 12.5144V2.09705C17.7001 1.16102 16.9374 0.398438 16.0015 0.398438H1.99885ZM1.99885 0.998438H16.0015C16.6157 0.998438 17.1001 1.48286 17.1001 2.09705V12.5144C17.1001 13.1286 16.6157 13.6125 16.0015 13.6125H10.6426C10.5253 13.6126 10.419 13.6811 10.3702 13.7877L9.00146 16.7771L7.63095 13.7877H7.63082C7.58207 13.6811 7.47573 13.6126 7.35841 13.6125H1.99887C1.38467 13.6125 0.900798 13.1286 0.900798 12.5144V2.09705C0.900798 1.48286 1.38467 0.998438 1.99887 0.998438H1.99885ZM8.98079 3.09494H8.98066C8.85999 3.10271 8.75579 3.18226 8.71642 3.2965L7.7678 6.0229L4.87734 6.08264C4.74984 6.08558 4.63815 6.16875 4.59891 6.28996C4.55967 6.41117 4.60132 6.54388 4.70283 6.62103L7.00495 8.366L6.16937 11.1292C6.13201 11.2515 6.1762 11.3838 6.27959 11.4591C6.38285 11.5344 6.52254 11.5361 6.62752 11.4632L8.99992 9.81324L11.373 11.4632H11.3731C11.4781 11.5361 11.6178 11.5344 11.7211 11.4591C11.8245 11.3838 11.8687 11.2515 11.8313 11.1292L10.994 8.366L13.2973 6.62103C13.3989 6.54375 13.4406 6.41076 13.4009 6.28942C13.3613 6.16808 13.2492 6.08505 13.1216 6.08264L10.2329 6.0229L9.28425 3.2965C9.24005 3.1686 9.11576 3.08597 8.98063 3.09494H8.98079ZM9.00008 4.30848L9.73427 6.41784V6.41771C9.77539 6.53637 9.88628 6.61686 10.0119 6.61927L12.2473 6.66441L10.4649 8.01321C10.3643 8.08914 10.322 8.21972 10.3588 8.34026L11.0069 10.4772L9.17109 9.2022V9.20207C9.06837 9.13109 8.9323 9.13109 8.82958 9.20207L6.99382 10.4771L7.64068 8.34013V8.34026C7.67738 8.21973 7.63479 8.08901 7.53408 8.01321L5.75335 6.66441L7.98874 6.61927C8.11437 6.61686 8.22526 6.53637 8.26638 6.41771L9.00008 4.30848Z" :fill="((competitor.my_business) ? '#FFFFFF' : '#666666')" :stroke="((competitor.my_business) ? '#FFFFFF' : '#666666')" stroke-width="0.5"/>
                                                    </svg>
                                                </div>
                                                <div style="float: left; padding-left: 5px;">
                                                    <span>
                                                        Rating:
                                                    </span>
                                                </div>
                                                <div v-show="competitor.reviews != 'pending'" style="float: left; padding-left: 5px;">
                                                    {{ competitor.rating }}
                                                </div>
                                                <div style="float: left; padding-left: 5px;">
                                                    <span v-if="competitor.reviews == 'pending'">
                                                        <i class="fa fa-spin fa-spinner"></i>
                                                    </span>
                                                    <span v-else>
                                                        <v-rating
                                                            style="margin-top: -2px;"
                                                            :value="(parseFloat(competitor.rating) || 0)"
                                                            :color="'orange ligten-1'"
                                                            dense
                                                            half-increments
                                                            readonly
                                                            size="18"
                                                    ></v-rating>
                                                    </span>
                                                </div>
                                                <div v-show="competitor.reviews != 'pending'" style="float: left; padding-left: 5px;">
                                                    ({{ ((competitor.rating_count) ? competitor.rating_count : 0) }})
                                                </div>
                                                <div style="clear: both;"></div>
                                            </div>

                                            <div style="padding-bottom: 14px; padding-left: 10px; padding-right: 10px; padding-top: 20px;" :style="((competitor.my_business) ? 'border-bottom: 1px solid rgba(255, 255, 255, 0.05);' : 'border-bottom: 1px solid rgba(0, 0, 0, 0.05);')">
                                                <div style="float: left; padding-right: 5px;">
                                                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M8.23 0.871667C4.166 0.871667 0.871667 4.16611 0.871667 8.23C0.871667 12.2939 4.1661 15.5883 8.23 15.5883C12.2939 15.5883 15.5883 12.2939 15.5883 8.23C15.5883 4.1661 12.2939 0.871667 8.23 0.871667ZM0.5 8.23C0.5 3.96078 3.96078 0.5 8.23 0.5C12.4992 0.5 15.96 3.96078 15.96 8.23C15.96 12.4992 12.4992 15.96 8.23 15.96C3.96078 15.96 0.5 12.4992 0.5 8.23Z" :fill="((competitor.my_business) ? '#FFFFFF' : '#666666')" :stroke="((competitor.my_business) ? '#FFFFFF' : '#666666')"/>
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.22878 3.42986C8.6076 3.42986 8.91461 3.73688 8.91461 4.11569V7.94641L11.1141 10.1461C11.382 10.4138 11.382 10.8481 11.1141 11.1159C10.8463 11.3838 10.4121 11.3838 10.1443 11.1159L7.7439 8.71544C7.6153 8.58684 7.54297 8.41244 7.54297 8.23052V4.11552C7.54297 3.7367 7.84999 3.42969 8.2288 3.42969L8.22878 3.42986Z" :fill="((competitor.my_business) ? '#FFFFFF' : '#666666')"/>
                                                    </svg>
                                                </div>
                                                <div style="float: left; padding-left: 5px;">
                                                    <span>
                                                        Years:
                                                    </span>
                                                </div>
                                                <div style="float: left; padding-left: 5px;">
                                                    {{ competitor.years_in_business || "Not Found" }}
                                                </div>
                                                <div style="clear: both;"></div>
                                            </div>

                                            <div style="padding-bottom: 14px; padding-left: 10px; padding-right: 10px; padding-top: 20px;" :style="((competitor.my_business) ? 'border-bottom: 1px solid rgba(255, 255, 255, 0.05);' : 'border-bottom: 1px solid rgba(0, 0, 0, 0.05);')">
                                                <div style="float: left; padding-right: 5px; padding-top: 5px;">
                                                    <svg width="18" height="11" viewBox="0 0 18 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M0.348113 0.0913372C0.680043 -0.0982723 1.10267 0.0168542 1.29244 0.348475L1.296 0.354656C1.29986 0.360992 1.3062 0.371654 1.31516 0.386489C1.33324 0.416159 1.36198 0.462211 1.40108 0.522167C1.47943 0.64208 1.59965 0.81763 1.7616 1.03011C2.08595 1.45601 2.57427 2.02559 3.22439 2.59442C4.52492 3.73239 6.44633 4.84624 8.99931 4.84624C11.5523 4.84624 13.4735 3.73239 14.7742 2.59442C15.4245 2.02559 15.9126 1.45601 16.2371 1.03011C16.3989 0.817634 16.5192 0.642088 16.5975 0.522167C16.6366 0.462211 16.6652 0.416159 16.6833 0.386489C16.6924 0.371654 16.6987 0.360992 16.7026 0.354656L16.7058 0.348939L16.7065 0.348011C16.8965 0.0168535 17.3188 -0.0981028 17.6505 0.0913366C17.9824 0.2811 18.0979 0.703878 17.9081 1.03598L17.307 0.692461C17.9081 1.03598 17.9082 1.03567 17.9081 1.03598L17.9073 1.03722L17.9064 1.03876L17.9036 1.04355L17.8951 1.05808C17.8881 1.06998 17.8782 1.08651 17.8656 1.10722C17.8404 1.14848 17.8042 1.20658 17.7568 1.27921C17.6621 1.42432 17.5227 1.62737 17.3383 1.86921C16.9705 2.35195 16.4203 2.99389 15.6859 3.63657C14.2173 4.92163 11.9849 6.23082 8.99954 6.23082C6.01417 6.23082 3.78163 4.92163 2.31317 3.63657C1.57871 2.99389 1.02855 2.35195 0.660644 1.86921C0.476447 1.62737 0.337058 1.42432 0.242341 1.27921C0.194901 1.20659 0.158739 1.14848 0.133551 1.10722C0.12088 1.08651 0.11099 1.06998 0.104036 1.05808L0.0955373 1.04355L0.0927557 1.03876L0.091365 1.03645C0.0912104 1.03614 0.0910561 1.03598 0.692197 0.692462L0.091365 1.03645C-0.0982445 0.704516 0.016728 0.281093 0.348657 0.0913251L0.348113 0.0913372Z" :fill="((competitor.my_business) ? '#FFFFFF' : '#666666')"/>
                                                    <path d="M2.56639 6.02556L1.18181 7.41014C0.91138 7.68042 0.473134 7.68042 0.202704 7.41014C-0.0675679 7.13972 -0.0675679 6.70147 0.202704 6.43104L1.58729 5.04645C1.85772 4.77618 2.29596 4.77618 2.56639 5.04645C2.83667 5.31688 2.83667 5.75513 2.56639 6.02556Z" :fill="((competitor.my_business) ? '#FFFFFF' : '#666666')"/>
                                                    <path d="M16.8178 7.41014L15.4332 6.02556C15.1629 5.75513 15.1629 5.31688 15.4332 5.04645C15.7036 4.77618 16.1418 4.77618 16.4123 5.04645L17.7969 6.43104C18.0671 6.70147 18.0671 7.13971 17.7969 7.41014C17.5264 7.68042 17.0882 7.68042 16.8178 7.41014Z" :fill="((competitor.my_business) ? '#FFFFFF' : '#666666')"/>
                                                    <path d="M5.14001 9.25854C4.998 9.6135 4.59515 9.78627 4.24003 9.64425C3.88507 9.50223 3.71246 9.09923 3.85432 8.74426L4.54661 7.01353C4.68862 6.65857 5.09147 6.4858 5.44644 6.62782C5.80155 6.76983 5.97416 7.17284 5.83214 7.5278L5.14001 9.25854Z" :fill="((competitor.my_business) ? '#FFFFFF' : '#666666')"/>
                                                    <path d="M13.759 9.64424C13.4041 9.78625 13.0011 9.61349 12.859 9.25854L12.1669 7.5278C12.0249 7.17284 12.1975 6.76984 12.5526 6.62782C12.9076 6.48581 13.3104 6.65857 13.4524 7.01353L14.1447 8.74426C14.2867 9.09922 14.114 9.50222 13.759 9.64424Z" :fill="((competitor.my_business) ? '#FFFFFF' : '#666666')"/>
                                                    <path d="M9.69318 9.69256C9.69318 10.0749 9.3832 10.3849 9.00089 10.3849C8.61858 10.3849 8.30859 10.0749 8.30859 9.69256V7.96183C8.30859 7.57952 8.61858 7.26953 9.00089 7.26953C9.3832 7.26953 9.69318 7.57952 9.69318 7.96183V9.69256Z" :fill="((competitor.my_business) ? '#FFFFFF' : '#666666')"/>
                                                    </svg>
                                                </div>
                                                <div style="float: left; padding-left: 5px;">
                                                    <span>
                                                        Visibility:
                                                    </span>
                                                </div>
                                                <div style="float: left; padding-left: 5px;">
                                                    {{ competitor.visibility }}%

                                                    <span v-if="search.properties.searches.status == 'pending'">
                                                        <i class="fa fa-spin fa-spinner"></i>
                                                    </span>
                                                </div>
                                                <div style="clear: both;"></div>
                                            </div>

                                            <div style="padding-bottom: 14px; padding-left: 10px; padding-right: 10px; padding-top: 20px;" :style="((competitor.my_business) ? 'border-bottom: 1px solid rgba(255, 255, 255, 0.05);' : 'border-bottom: 1px solid rgba(0, 0, 0, 0.05);')">
                                                <div style="float: left; padding-right: 5px;">
                                                    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M4.66942 3.31585V4.28139C4.66942 4.54877 4.45267 4.76535 4.18546 4.76535C3.91814 4.76535 3.70135 4.5488 3.70135 4.28139V4.18139H3.70149V3.31774H3.11217C2.78215 3.31774 2.46582 3.44875 2.23252 3.68205C2.23252 3.68205 2.23252 3.68205 2.23252 3.68205M4.66942 3.31585L1.76807 4.56171C1.76807 4.20531 1.90977 3.86341 2.16181 3.61134L2.23252 3.68205M4.66942 3.31585H8.13285V4.2795C8.13285 4.54672 8.34943 4.76347 8.61682 4.76347C8.88421 4.76347 9.10079 4.54671 9.10079 4.2795V3.31585H12.5642V4.2795C12.5642 4.54674 12.781 4.76347 13.0482 4.76347C13.3155 4.76347 13.5323 4.54675 13.5323 4.2795V3.31585H14.1215C14.1215 3.31585 14.1216 3.31585 14.1216 3.31585C14.4515 3.31589 14.7678 3.44691 15.0011 3.68017C15.2344 3.91348 15.3656 4.22982 15.3656 4.55982L15.3656 6.20894H1.86807M4.66942 3.31585L1.86807 6.20894M2.23252 3.68205C1.99922 3.91538 1.86807 4.23185 1.86807 4.56171V6.20894M2.23252 3.68205L1.86807 6.20894M16.3335 4.55969C16.3335 3.97293 16.1004 3.4103 15.6856 2.99552C15.2708 2.58074 14.7082 2.34761 14.1214 2.34761H13.5322V1.38397C13.5322 1.1167 13.3155 0.9 13.0481 0.9C12.7809 0.9 12.5641 1.11674 12.5641 1.38397V2.34761H9.10071V1.38397C9.10071 1.11675 8.88413 0.9 8.61675 0.9C8.34936 0.9 8.13278 1.11676 8.13278 1.38397V2.34761H4.66935V1.38397C4.66935 1.11673 4.45261 0.9 4.18538 0.9C3.91804 0.9 3.70128 1.11671 3.70128 1.38397V2.34761H3.11207C2.52531 2.34761 1.96269 2.58074 1.54791 2.99552C1.13312 3.41031 0.9 3.97293 0.9 4.55968V13.5528C0.9 14.1395 1.13313 14.7021 1.54789 15.1169C1.9627 15.5318 2.52533 15.7648 3.11207 15.7648H14.1212C14.708 15.7648 15.2706 15.5318 15.6854 15.1169C16.1002 14.7021 16.3333 14.1395 16.3333 13.5528L16.3335 4.55969ZM15.3656 13.5549C15.3656 13.8848 15.2344 14.2012 15.0011 14.4346C14.7678 14.6678 14.4515 14.7989 14.1215 14.7989H3.11231C2.78232 14.7989 2.46596 14.6678 2.23265 14.4345C1.99934 14.2012 1.86821 13.8848 1.86821 13.5549V7.17489H15.3657L15.3656 13.5549Z" :fill="((competitor.my_business) ? '#FFFFFF' : '#666666')" :stroke="((competitor.my_business) ? '#FFFFFF' : '#666666')" stroke-width="0.2"/>
                                                    </svg>
                                                </div>
                                                <div style="float: left; padding-left: 5px;">
                                                    <span>
                                                        Booking:
                                                    </span>
                                                </div>
                                                <div style="float: left; padding-left: 5px;">
                                                    {{ competitor.booking ? 'Active' : 'Inactive' }}
                                                </div>
                                                <div style="clear: both;"></div>
                                            </div>

                                            <div style="padding-bottom: 14px; padding-left: 10px; padding-right: 10px; padding-top: 20px;" :style="((competitor.my_business) ? 'border-bottom: 1px solid rgba(255, 255, 255, 0.05);' : 'border-bottom: 1px solid rgba(0, 0, 0, 0.05);')">
                                                <div style="float: left; padding-right: 5px;">
                                                    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M3.07378 1.00001C1.92551 1.00001 1 1.96022 1 3.12059V11.0637C1 12.2239 1.92535 13.186 3.07378 13.186H10.3696L12.8173 15.6353C12.9488 15.7668 13.1466 15.8062 13.3184 15.7349C13.4904 15.6638 13.6024 15.4962 13.6026 15.3101V13.186H14.0339C15.1823 13.186 16.1077 12.2239 16.1077 11.0637V3.12058C16.1077 1.96037 15.1821 1 14.0339 1L3.07378 1.00001ZM3.07378 1.92008H14.0342C14.6744 1.92008 15.1879 2.43971 15.1879 3.12059V11.0637C15.1879 11.7444 14.6742 12.2659 14.0342 12.2659H13.1428C12.8887 12.2659 12.6828 12.4718 12.6828 12.7259V14.1995L10.8857 12.4007C10.7994 12.3144 10.6825 12.2659 10.5604 12.2659H3.07378C2.43378 12.2659 1.92007 11.7444 1.92007 11.0637V3.12062C1.92007 2.43989 2.43363 1.92011 3.07378 1.92011L3.07378 1.92008Z" :fill="((competitor.my_business) ? '#FFFFFF' : '#666666')"/>
                                                        <path d="M12.7465 15.706L12.7465 15.706C12.9067 15.8661 13.1475 15.9141 13.3568 15.8273C13.5661 15.7407 13.7024 15.5366 13.7026 15.3102V15.3101V13.286H14.0339C15.2402 13.286 16.2077 12.2765 16.2077 11.0637V3.12058C16.2077 1.90769 15.2399 0.9 14.0339 0.9L3.07378 0.900012C1.86777 0.900012 0.9 1.90754 0.9 3.12059V11.0637C0.9 12.2765 1.8675 13.286 3.07378 13.286H10.3282L12.7465 15.706ZM12.5828 12.7259V13.9579L10.9565 12.33L10.9564 12.33C10.8514 12.2249 10.709 12.1659 10.5604 12.1659H3.07378C2.49211 12.1659 2.02007 11.6924 2.02007 11.0637V3.12062C2.02007 2.49215 2.49178 2.02011 3.07378 2.02011H3.15742L3.15743 2.02008H14.0342C14.6162 2.02008 15.0879 2.49197 15.0879 3.12059V11.0637C15.0879 11.6923 14.6159 12.1659 14.0342 12.1659H13.1428C12.8335 12.1659 12.5828 12.4165 12.5828 12.7259Z" :stroke="((competitor.my_business) ? '#FFFFFF' : '#666666')" stroke-width="0.2"/>
                                                    </svg>
                                                </div>
                                                <div style="float: left; padding-left: 5px;">
                                                    <span>
                                                        Messaging:
                                                    </span>
                                                </div>
                                                <div style="float: left; padding-left: 5px;">
                                                    {{ competitor.messaging ? 'Active' : 'Inactive' }}
                                                </div>
                                                <div style="clear: both;"></div>
                                            </div>

                                            <div style="padding-bottom: 14px; padding-left: 10px; padding-right: 10px; padding-top: 20px;" :style="((competitor.my_business) ? 'border-bottom: 1px solid rgba(255, 255, 255, 0.05);' : 'border-bottom: 1px solid rgba(0, 0, 0, 0.05);')">
                                                <div style="float: left; padding-right: 5px;">
                                                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M8.23 0.871667C4.166 0.871667 0.871667 4.16611 0.871667 8.23C0.871667 12.2939 4.1661 15.5883 8.23 15.5883C12.2939 15.5883 15.5883 12.2939 15.5883 8.23C15.5883 4.1661 12.2939 0.871667 8.23 0.871667ZM0.5 8.23C0.5 3.96078 3.96078 0.5 8.23 0.5C12.4992 0.5 15.96 3.96078 15.96 8.23C15.96 12.4992 12.4992 15.96 8.23 15.96C3.96078 15.96 0.5 12.4992 0.5 8.23Z" :fill="((competitor.my_business) ? '#FFFFFF' : '#666666')" :stroke="((competitor.my_business) ? '#FFFFFF' : '#666666')"/>
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.22878 3.42986C8.6076 3.42986 8.91461 3.73688 8.91461 4.11569V7.94641L11.1141 10.1461C11.382 10.4138 11.382 10.8481 11.1141 11.1159C10.8463 11.3838 10.4121 11.3838 10.1443 11.1159L7.7439 8.71544C7.6153 8.58684 7.54297 8.41244 7.54297 8.23052V4.11552C7.54297 3.7367 7.84999 3.42969 8.2288 3.42969L8.22878 3.42986Z" :fill="((competitor.my_business) ? '#FFFFFF' : '#666666')"/>
                                                    </svg>
                                                </div>
                                                <div style="float: left; padding-left: 5px;">
                                                    <div v-if="competitor.open_hours == 'pending'">
                                                        <i class="fa fa-spin fa-spinner"></i>
                                                    </div>
                                                    <div v-else>
                                                        <div v-if="competitor.open_hours == 'Open 24/7'">
                                                            Open 24/7
                                                        </div>
                                                        <div v-else>
                                                            <div style="font-weight: bold; margin-bottom: 10px;">Open Hours</div>
                                                            <div v-for="(item, index) in competitor.open_hours" :key="index" style="padding-bottom: 5px;">
                                                                {{ index }} - {{ item || "Not Found" }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div style="clear: both;"></div>
                                            </div>

                                            <div style="padding-bottom: 14px; padding-left: 10px; padding-right: 10px; padding-top: 20px;" :style="((competitor.my_business) ? 'border-bottom: 1px solid rgba(255, 255, 255, 0.05);' : 'border-bottom: 1px solid rgba(0, 0, 0, 0.05);')">
                                                <div style="float: left; padding-right: 5px;">
                                                    <svg width="19" height="12" viewBox="0 0 19 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <circle cx="0.806354" cy="0.806354" r="0.806354" :fill="((competitor.my_business) ? '#FFFFFF' : '#666666')"/>
                                                        <rect x="3.72266" width="14.8865" height="1.61271" rx="0.806354" :fill="((competitor.my_business) ? '#FFFFFF' : '#666666')"/>
                                                        <circle cx="0.806354" cy="5.76729" r="0.806354" :fill="((competitor.my_business) ? '#FFFFFF' : '#666666')"/>
                                                        <rect x="3.72266" y="4.96094" width="14.8865" height="1.61271" rx="0.806354" :fill="((competitor.my_business) ? '#FFFFFF' : '#666666')"/>
                                                        <circle cx="0.806354" cy="10.7321" r="0.806354" :fill="((competitor.my_business) ? '#FFFFFF' : '#666666')"/>
                                                        <rect x="3.72266" y="9.92578" width="14.8865" height="1.61271" rx="0.806354" :fill="((competitor.my_business) ? '#FFFFFF' : '#666666')"/>
                                                    </svg>
                                                </div>
                                                <div v-if="competitor && competitor.services" style="float: left; padding-left: 5px;">
                                                    <div v-if="competitor.services == 'pending'">
                                                        <i class="fa fa-spin fa-spinner"></i>
                                                    </div>
                                                    <div v-else>
                                                        <div style="font-weight: bold; margin-bottom: 10px;">Services</div>
                                                        <div v-if="!competitor.profile_url">
                                                            <div style="padding-top: 4px;">
                                                                Not Found
                                                            </div>
                                                        </div>
                                                        <div v-else v-for="(item, index) in competitor.services" :key="index" style="padding-bottom: 10px;">
                                                            <div style="float: left; padding-top: 4px;">
                                                                <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.6896 1.78231L5.62069 9.80262C5.20687 10.2139 4.55176 10.2139 4.13794 9.80262L0.310367 5.99811C-0.103456 5.58678 -0.103456 4.93563 0.310367 4.5243C0.724189 4.11297 1.3793 4.11297 1.79312 4.5243L4.87931 7.59189L12.2069 0.308496C12.6207 -0.102832 13.2758 -0.102832 13.6896 0.308496C14.1034 0.719824 14.1033 1.37111 13.6896 1.78231Z" :fill="((competitor.my_business) ? '#FFFFFF' : '#54AC0E')"/>
                                                                </svg>
                                                            </div>
                                                            <div style="float: left; padding-left: 12px;">
                                                                {{ item }}
                                                            </div>
                                                            <div style="clear: both;"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div style="clear: both;"></div>
                                            </div>

                                            <div style="padding-bottom: 14px; padding-left: 10px; padding-right: 10px; padding-top: 20px;" :style="((competitor.my_business) ? 'border-bottom: 1px solid rgba(255, 255, 255, 0.05);' : 'border-bottom: 1px solid rgba(0, 0, 0, 0.05);')">
                                                <div style="float: left; padding-right: 5px;">
                                                    <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M19.41 12.0523V12.0522V7.71777V7.71774C19.4099 7.25964 19.2887 6.80963 19.0585 6.41352L18.0984 4.7525C17.7377 4.12801 17.0717 3.743 16.3506 3.74228H16.3505H12.9014V2.53642C12.9014 2.10238 12.729 1.6862 12.4221 1.37927L12.3516 1.44981L12.4221 1.37926C12.1152 1.07236 11.699 0.9 11.265 0.9H2.53642C2.10238 0.9 1.6862 1.07236 1.37927 1.37926L1.37925 1.37928C1.0725 1.68617 0.9 2.10236 0.9 2.53642V10.9001C0.9 11.3342 1.07251 11.7503 1.37924 12.0572L1.37928 12.0573C1.68617 12.364 2.10236 12.5365 2.53642 12.5365H3.39922C3.54303 13.1941 3.97645 13.7536 4.58104 14.0565L4.58105 14.0565C5.21059 14.3717 5.95205 14.3717 6.58172 14.0565L6.58174 14.0565C7.18619 13.7536 7.61973 13.1941 7.76343 12.5365H13.5182C13.6619 13.1941 14.0954 13.7536 14.6999 14.0565L14.6999 14.0565C15.3296 14.3717 16.071 14.3717 16.7006 14.0565L16.7006 14.0565C17.3052 13.7536 17.7386 13.1941 17.8824 12.5365H19.3098H19.4098L19.4098 12.4366L19.41 12.0523ZM17.257 5.24248L18.0992 6.692H12.9013V4.71619H16.3465C16.7221 4.71656 17.0691 4.91708 17.2568 5.24224L17.257 5.24248ZM6.58174 10.0485L6.58172 10.0484C5.95205 9.73319 5.21062 9.73319 4.58105 10.0484L4.58104 10.0485C3.97589 10.3516 3.54224 10.9118 3.39883 11.5702H2.53647C2.35928 11.5702 2.18936 11.4997 2.06393 11.3744C1.93871 11.2491 1.86833 11.0792 1.86833 10.9019V2.54028C1.86833 2.36305 1.9387 2.19313 2.06399 2.06773L1.99325 1.99705L2.06393 2.0678C2.18933 1.94251 2.35923 1.87213 2.53647 1.87213H11.265C11.4423 1.87213 11.6123 1.94252 11.7375 2.06773C11.8628 2.19317 11.9333 2.36308 11.9333 2.54028V11.5684H7.76343C7.61974 10.9108 7.18619 10.3513 6.58174 10.0485ZM4.68354 11.1561L4.61288 11.0853L4.68354 11.1561C4.92184 10.9182 5.24481 10.7847 5.58159 10.7849C5.91839 10.7853 6.24125 10.9194 6.47902 11.1578L6.47904 11.1578C6.71681 11.3961 6.85017 11.7191 6.84969 12.0559C6.84883 12.3919 6.71459 12.7139 6.47668 12.951L6.47667 12.9511C6.23874 13.1884 5.91651 13.3216 5.5805 13.3216H5.51128C5.1997 13.3046 4.90436 13.1734 4.68269 12.9516C4.44464 12.7134 4.31103 12.3904 4.31113 12.0536C4.31125 11.7169 4.44524 11.394 4.68354 11.1561ZM13.5186 11.5682H12.9016V7.65662H18.4377C18.4402 7.68032 18.442 7.69949 18.442 7.71791V11.5683H17.8828C17.739 10.9107 17.3056 10.3512 16.701 10.0483L16.701 10.0483C16.0714 9.73307 15.33 9.73308 14.7003 10.0483L14.7003 10.0483C14.0959 10.3512 13.6623 10.9106 13.5186 11.5682ZM15.6996 13.3216C15.3636 13.3216 15.0411 13.1883 14.8032 12.9509C14.5647 12.713 14.4306 12.3902 14.4303 12.0535C14.43 11.7167 14.5635 11.3937 14.8015 11.1554C15.0394 10.9171 15.3623 10.7832 15.699 10.783C16.0358 10.7829 16.3588 10.9165 16.5969 11.1546L16.6676 11.0839L16.5969 11.1546C16.8351 11.3926 16.969 11.7156 16.969 12.0524C16.969 12.3889 16.8352 12.7118 16.5972 12.9498C16.3595 13.1875 16.0373 13.3211 15.7013 13.3216L15.6996 13.3216Z" :fill="((competitor.my_business) ? '#FFFFFF' : '#666666')" :stroke="((competitor.my_business) ? '#FFFFFF' : '#666666')" stroke-width="0.2"/>
                                                    </svg>
                                                </div>
                                                <div v-if="competitor && competitor.service_areas" style="float: left; padding-left: 5px;">
                                                    <div v-if="competitor.service_areas == 'pending'">
                                                        <i class="fa fa-spin fa-spinner"></i>
                                                    </div>
                                                    <div v-else>
                                                        <div style="font-weight: bold; margin-bottom: 10px;">Service Areas</div>
                                                        <div v-if="!competitor.profile_url">
                                                            <div style="padding-top: 4px;">
                                                                Not Found
                                                            </div>
                                                        </div>
                                                        <div v-else v-for="(item, index) in competitor.service_areas" :key="index" style="padding-bottom: 10px;">
                                                            <div style="float: left; padding-top: 4px;">
                                                                <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.6896 1.78231L5.62069 9.80262C5.20687 10.2139 4.55176 10.2139 4.13794 9.80262L0.310367 5.99811C-0.103456 5.58678 -0.103456 4.93563 0.310367 4.5243C0.724189 4.11297 1.3793 4.11297 1.79312 4.5243L4.87931 7.59189L12.2069 0.308496C12.6207 -0.102832 13.2758 -0.102832 13.6896 0.308496C14.1034 0.719824 14.1033 1.37111 13.6896 1.78231Z" :fill="((competitor.my_business) ? '#FFFFFF' : '#54AC0E')"/>
                                                                </svg>
                                                            </div>
                                                            <div style="float: left; padding-left: 12px;">
                                                                {{ item }}
                                                            </div>
                                                            <div style="clear: both;"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div style="clear: both;"></div>
                                            </div>

                                            <div v-if="competitor.details != 'pending' && competitor.details && competitor.details.length > 0" style="padding-bottom: 14px; padding-left: 10px; padding-right: 10px; padding-top: 20px;">
                                                <div style="float: left; padding-right: 5px;">
                                                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M4.94308 4.04086L4.94314 4.0408C5.29437 3.68957 5.77078 3.49219 6.26742 3.49219H17.4851C17.9817 3.49219 18.4581 3.68957 18.8094 4.0408L18.8094 4.04085C19.1607 4.392 19.358 4.86834 19.358 5.36523V18.8391C19.358 19.336 19.1607 19.8124 18.8094 20.1635L18.8094 20.1636C18.4581 20.5148 17.9817 20.7122 17.4851 20.7122H6.26742C5.77077 20.7122 5.29437 20.5148 4.94314 20.1636L4.94308 20.1635C4.59183 19.8124 4.39453 19.336 4.39453 18.8391V5.36523C4.39453 4.86834 4.59182 4.392 4.94308 4.04086ZM18.6013 19.9558C18.8972 19.6598 19.0637 19.2582 19.0637 18.8394V5.36554C19.0637 4.9468 18.8972 4.54517 18.6013 4.24921C18.3052 3.95317 17.9037 3.78691 17.4851 3.78691H6.26742C5.84878 3.78691 5.44727 3.95318 5.15124 4.24921C4.85528 4.54517 4.68879 4.9468 4.68879 5.36554V18.8394C4.68879 19.2582 4.85528 19.6598 5.15124 19.9558C5.44727 20.2518 5.84879 20.4181 6.26742 20.4181H17.4851C17.9037 20.4181 18.3052 20.2518 18.6013 19.9558Z" :fill="((competitor.my_business) ? '#FFFFFF' : '#666666')" :stroke="((competitor.my_business) ? '#FFFFFF' : '#666666')" />
                                                        <path d="M8.07048 11.5625H7.00268C6.7714 11.5625 6.55771 11.6859 6.44214 11.886C6.32658 12.0863 6.32658 12.3331 6.44214 12.5332C6.55771 12.7335 6.77139 12.8569 7.00268 12.8569H8.07048C8.30161 12.8569 8.51529 12.7335 8.63101 12.5332C8.74658 12.3331 8.74658 12.0863 8.63101 11.886C8.5153 11.6859 8.30162 11.5625 8.07048 11.5625Z" :fill="((competitor.my_business) ? '#FFFFFF' : '#666666')"/>
                                                        <path d="M16.7511 11.5625H10.4285C10.1972 11.5625 9.98349 11.6859 9.86792 11.886C9.75236 12.0863 9.75236 12.3331 9.86792 12.5332C9.98349 12.7335 10.1972 12.8569 10.4285 12.8569H16.7511C16.9824 12.8569 17.1961 12.7335 17.3116 12.5332C17.4272 12.3331 17.4272 12.0863 17.3116 11.886C17.1961 11.6859 16.9824 11.5625 16.7511 11.5625Z" :fill="((competitor.my_business) ? '#FFFFFF' : '#666666')"/>
                                                        <path d="M8.07048 7.67969H7.00268C6.7714 7.67969 6.55771 7.80308 6.44214 8.00336C6.32658 8.2035 6.32658 8.4503 6.44214 8.65042C6.55771 8.8507 6.77139 8.9741 7.00268 8.9741H8.07048C8.30161 8.9741 8.51529 8.8507 8.63101 8.65042C8.74658 8.45029 8.74658 8.20349 8.63101 8.00336C8.5153 7.80308 8.30162 7.67969 8.07048 7.67969Z" :fill="((competitor.my_business) ? '#FFFFFF' : '#666666')"/>
                                                        <path d="M16.7511 7.67969H10.4285C10.1972 7.67969 9.98349 7.80308 9.86792 8.00336C9.75236 8.2035 9.75236 8.4503 9.86792 8.65042C9.98349 8.8507 10.1972 8.9741 10.4285 8.9741H16.7511C16.9824 8.9741 17.1961 8.8507 17.3116 8.65042C17.4272 8.45029 17.4272 8.20349 17.3116 8.00336C17.1961 7.80308 16.9824 7.67969 16.7511 7.67969Z" :fill="((competitor.my_business) ? '#FFFFFF' : '#666666')"/>
                                                        <path d="M8.07048 15.4453H7.00268C6.7714 15.4453 6.55771 15.5687 6.44214 15.7688C6.32658 15.9691 6.32658 16.2158 6.44214 16.416C6.55771 16.6163 6.77139 16.7396 7.00268 16.7396H8.07048C8.30161 16.7396 8.51529 16.6163 8.63101 16.416C8.74658 16.2158 8.74658 15.9691 8.63101 15.7688C8.5153 15.5687 8.30162 15.4453 8.07048 15.4453Z" :fill="((competitor.my_business) ? '#FFFFFF' : '#666666')"/>
                                                        <path d="M16.7511 15.4453H10.4285C10.1972 15.4453 9.98349 15.5687 9.86792 15.7688C9.75236 15.9691 9.75236 16.2158 9.86792 16.416C9.98349 16.6163 10.1972 16.7396 10.4285 16.7396H16.7511C16.9824 16.7396 17.1961 16.6163 17.3116 16.416C17.4272 16.2158 17.4272 15.9691 17.3116 15.7688C17.1961 15.5687 16.9824 15.4453 16.7511 15.4453Z" :fill="((competitor.my_business) ? '#FFFFFF' : '#666666')"/>
                                                    </svg>
                                                </div>
                                                <div style="float: left; padding-left: 5px;">
                                                    <div v-if="competitor.details == 'pending'">
                                                        <i class="fa fa-spin fa-spinner"></i>
                                                    </div>
                                                    <div v-else>
                                                        <div v-if="competitor.details">
                                                            <div style="font-weight: bold; margin-bottom: 10px;">Details</div>
                                                            <div v-for="(item, index) in competitor.details" :key="index" style="padding-bottom: 10px;">
                                                                <div style="float: left; padding-top: 4px;">
                                                                    <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.6896 1.78231L5.62069 9.80262C5.20687 10.2139 4.55176 10.2139 4.13794 9.80262L0.310367 5.99811C-0.103456 5.58678 -0.103456 4.93563 0.310367 4.5243C0.724189 4.11297 1.3793 4.11297 1.79312 4.5243L4.87931 7.59189L12.2069 0.308496C12.6207 -0.102832 13.2758 -0.102832 13.6896 0.308496C14.1034 0.719824 14.1033 1.37111 13.6896 1.78231Z" :fill="((competitor.my_business) ? '#FFFFFF' : '#54AC0E')"/>
                                                                    </svg>
                                                                </div>
                                                                <div style="float: left; padding-left: 12px;">
                                                                    {{ item }}
                                                                </div>
                                                                <div style="clear: both;"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div style="clear: both;"></div>
                                            </div>
                                        </div>
                                    </div>
                                </v-card>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="pt-3">
                    <v-skeleton-loader type="article, article, article, article, article, article, article"></v-skeleton-loader>
                </div>
            </div>
        </div>

        <div v-show="lsa_tab == 1 || $vuetify.breakpoint.xs || true">
            <div class="">
                <div v-if="search.properties.summary.grade">
                    <div class="flex flex-row flex-wrap">
                        <div class="w-full" style="position: relative;">
                            <div v-if="search.properties.summary.items" style="">
                                <div v-for="(item, index) in search.properties.summary.items" :key="index">
                                    <div v-if="!item.hidden && item.title != 'Service Areas Zip Codes' && item.title != 'Service Areas Counties' && item.title != 'Aggregate Rating'" class="dashboard-box stats-box w-full px-2 mb-5 mt-3">
                                        <v-card
                                            class="pa-2 pt-2 pb-6"
                                            tile
                                        >
                                            <div style="/*cursor: pointer;*/" @click="/*showSeoOnPageCategoryDescription(item.title, item.description)*/">
                                                <div v-if="item.title == 'Number of Reviews'" style="padding: 10px;">
                                                    <div class="float-right pr-2">
                                                        <div class="lsaaudit-badge-container">
                                                          <!-- Passed Badge -->
                                                          <span v-if="weeksWithReviews >= 8" class="lsaaudit-badge lsaaudit-badge-success">
                                                            <i class="mdi mdi-check-circle-outline"></i>
                                                            <span>Passed</span>
                                                          </span>

                                                          <!-- Needs Work Badge -->
                                                          <span v-if="weeksWithReviews < 8" class="lsaaudit-badge lsaaudit-badge-warning">
                                                            <i class="mdi mdi-alert-circle-outline"></i>
                                                            <span>Needs work</span>
                                                          </span>
                                                        </div>
                                                    </div>
                                                    
                                                    <div style="font-weight: bold; font-size: 16px;">
                                                        Reviews
                                                    </div>

                                                    <div style="height: 100px; overflow: hidden;">
                                                        <iframe v-if="reviewsScoreData" style="width: 100%; margin-top: 20px;" height="200" :src="'https://review-frequency-tracker-720.created.app?embed=true&reviews=' + reviewsScoreData" title="Review Frequency Tracker" frameBorder="0"></iframe>
                                                    </div>

                                                    <hr />
                                                </div>

                                                <div class="float-right pr-2">
                                                    <div class="lsaaudit-badge-container">
                                                      <!-- Passed Badge -->
                                                      <span v-if="item.passed === true" class="lsaaudit-badge lsaaudit-badge-success">
                                                        <i class="mdi mdi-check-circle-outline"></i>
                                                        <span>Passed</span>
                                                      </span>

                                                      <!-- Needs Work Badge -->
                                                      <span v-if="item.passed === false" class="lsaaudit-badge lsaaudit-badge-warning">
                                                        <i class="mdi mdi-alert-circle-outline"></i>
                                                        <span>Needs work</span>
                                                      </span>
                                                    </div>
                                                </div>

                                                <div style="padding: 10px;">
                                                    <div style="font-weight: bold; font-size: 16px;">
                                                        <span v-if="(search.keyword.toLowerCase().indexOf('law') != -1 || search.keyword.toLowerCase().indexOf('attorney') != -1 || search.keyword.toLowerCase().indexOf('real extate') != -1) && item.title == 'Google Guarantee'">
                                                            Google Verified
                                                        </span>
                                                        <span v-else>
                                                            {{ item.title }}
                                                        </span>
                                                    </div>

                                                    <div v-if="item.sub_title" style="padding-top: 10px; color: #757B89; font-size: 12px;">
                                                        <span v-if="(search.keyword.toLowerCase().indexOf('law') != -1 || search.keyword.toLowerCase().indexOf('attorney') != -1 || search.keyword.toLowerCase().indexOf('real extate') != -1) && item.title == 'Google Guarantee'">
                                                            {{ item.sub_title.replace("guaranteed", "Screened") }}
                                                        </span>
                                                        <span v-else>
                                                            {{ item.sub_title }}
                                                        </span>
                                                    </div>

                                                    <div v-if="item.sub_sub_title" style="padding-top: 10px; color: #757B89; font-size: 12px;">
                                                        {{ item.sub_sub_title }}
                                                    </div>

                                                    <div style="padding-top: 10px; color: #757B89; font-size: 12px;">
                                                        {{ item.description }}
                                                    </div>

                                                    <div v-if="item.title == 'Business Services' && search.properties.summary.my_competitor" style="padding-top: 10px; color: #757B89; font-size: 12px;">
                                                        <div v-for="(item, index) in search.properties.summary.my_competitor.services" :key="index" style="padding-bottom: 10px; float: left; width: 200px;">
                                                            <div v-if="item" style="float: left; padding-top: 4px;">
                                                                <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.6896 1.78231L5.62069 9.80262C5.20687 10.2139 4.55176 10.2139 4.13794 9.80262L0.310367 5.99811C-0.103456 5.58678 -0.103456 4.93563 0.310367 4.5243C0.724189 4.11297 1.3793 4.11297 1.79312 4.5243L4.87931 7.59189L12.2069 0.308496C12.6207 -0.102832 13.2758 -0.102832 13.6896 0.308496C14.1034 0.719824 14.1033 1.37111 13.6896 1.78231Z" :fill="'#54AC0E'"/>
                                                                </svg>
                                                            </div>
                                                            <div v-if="item" style="float: left; padding-left: 12px;">
                                                                {{ unEntity(item) }}
                                                            </div>
                                                            <div style="clear: both;"></div>
                                                        </div>
                                                        <div style="clear: both;"></div>

                                                        <div v-if="item.missing_services.length > 0">
                                                            <div style="border-radius: 5px; background: rgba(68, 70, 143, 0.10); padding: 20px; margin-top: 10px;">
                                                                <div style="float: left; padding-left: 10px;">
                                                                    <div class="mb-2"><strong style="color: #44468F;">Suggested Services used by competitors</strong></div>

                                                                    <div class="mb-2">You may consider using some of the following additional services if they are relevant to your business.</div>

                                                                    <div v-for="(item, index) in item.missing_services" :key="index" style="padding: 10px; color: #44468F; float: left; margin-bottom: 5px; border-radius: 30px; background: rgba(68, 70, 143, 0.10); margin-right: 10px;">
                                                                        {{ unEntity(item) }}
                                                                    </div>
                                                                    <div style="clear: both;"></div>
                                                                </div>

                                                                <div style="clear: both;"></div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div v-if="item.title == 'Service Areas' && search.properties.summary.my_competitor" style="padding-top: 10px; color: #757B89; font-size: 12px;">
                                                        <div v-for="(item, index) in search.properties.summary.my_competitor.service_areas" :key="index" style="padding-bottom: 10px; float: left; width: 200px;">
                                                            <div v-if="item" style="float: left; padding-top: 4px;">
                                                                <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.6896 1.78231L5.62069 9.80262C5.20687 10.2139 4.55176 10.2139 4.13794 9.80262L0.310367 5.99811C-0.103456 5.58678 -0.103456 4.93563 0.310367 4.5243C0.724189 4.11297 1.3793 4.11297 1.79312 4.5243L4.87931 7.59189L12.2069 0.308496C12.6207 -0.102832 13.2758 -0.102832 13.6896 0.308496C14.1034 0.719824 14.1033 1.37111 13.6896 1.78231Z" :fill="'#54AC0E'"/>
                                                                </svg>
                                                            </div>
                                                            <div v-if="item" style="float: left; padding-left: 12px;">
                                                                {{ unEntity(item) }}
                                                            </div>
                                                            <div style="clear: both;"></div>
                                                        </div>
                                                        <div style="clear: both;"></div>

                                                        <div v-if="item.missing_service_areas.length > 0">
                                                            <div style="border-radius: 5px; background: rgba(68, 70, 143, 0.10); padding: 20px; margin-top: 10px;">
                                                                <div style="float: right; padding: 10px; padding-top: 20px;">
                                                                    <a href="https://servicearea.tools.revulsab.com/" target="find-more-areas-btn" class="border-1 border-blue bg-blue text-white text-xs text-bold px-4 py-4 rounded cursor-pointer" @click="submitLsaAudit();" style="color: #FFFFFF !important;"><i class="mdi mdi-search-web" style="font-size: 16px;"></i> Find More Areas</a>
                                                                </div>

                                                                <div style="float: left; padding-left: 10px; width: calc(100% - 200px);">
                                                                    <div class="mb-2"><strong style="color: #44468F;">Suggested Areas used by competitors</strong></div>

                                                                    <div class="mb-2">You should consider using some of the following additional areas if they are relevant to your business.</div>

                                                                    <div v-for="(item, index) in item.missing_service_areas" :key="index" style="padding: 10px; color: #44468F; float: left; margin-bottom: 5px; border-radius: 30px; background: rgba(68, 70, 143, 0.10); margin-right: 10px;">
                                                                        {{ unEntity(item) }}
                                                                    </div>
                                                                    <div style="clear: both;"></div>
                                                                </div>

                                                                <div style="clear: both;"></div>
                                                            </div>
                                                        </div>

                                                        <div v-for="(item2, index2) in search.properties.summary.items" :key="'zp' + index2">
                                                            <div v-if="item2.title == 'Service Areas Zip Codes' || item2.title == 'Service Areas Counties'" style="border-radius: 5px; background: rgba(68, 70, 143, 0.10); padding: 20px; margin-top: 10px;">

                                                                <div style="padding-left: 10px;">
                                                                    <div class="float-right pr-2">
                                                                        <div class="lsaaudit-badge-container">
                                                                          <!-- Passed Badge -->
                                                                          <span v-if="item2.passed === true" class="lsaaudit-badge lsaaudit-badge-success">
                                                                            <i class="mdi mdi-check-circle-outline"></i>
                                                                            <span>Passed</span>
                                                                          </span>

                                                                          <!-- Needs Work Badge -->
                                                                          <span v-if="item2.passed === false" class="lsaaudit-badge lsaaudit-badge-warning">
                                                                            <i class="mdi mdi-alert-circle-outline"></i>
                                                                            <span>Needs work</span>
                                                                          </span>
                                                                        </div>
                                                                    </div>

                                                                    <div class="mb-2"><strong style="color: #44468F;">{{ item2.title }}</strong></div>

                                                                    <div style="padding: 10px; padding-left: 0px;">
                                                                        <div v-if="item2.sub_title" style="padding-top: 10px; color: #757B89; font-size: 12px;">
                                                                            <span v-if="(search.keyword.toLowerCase().indexOf('law') != -1 || search.keyword.toLowerCase().indexOf('attorney') != -1 || search.keyword.toLowerCase().indexOf('real extate') != -1) && item2.title == 'Google Guarantee'">
                                                                                {{ item2.sub_title.replace("guaranteed", "Screened") }}
                                                                            </span>
                                                                            <span v-else>
                                                                                {{ item2.sub_title }}
                                                                            </span>
                                                                        </div>

                                                                        <div v-if="item2.sub_sub_title" style="padding-top: 10px; color: #757B89; font-size: 12px;">
                                                                            {{ item2.sub_sub_title }}
                                                                        </div>

                                                                        <div style="padding-top: 10px; color: #757B89; font-size: 12px;">
                                                                            {{ item2.description }}
                                                                        </div>
                                                                    </div>
                                                                    <div style="clear: both;"></div>
                                                                </div>

                                                                <div style="clear: both;"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            <div style="clear: both;"></div>  

                                            </div>

                                            <div v-if="item.title == 'Number of Reviews'" class="-mt-4 -mb-6">
                                                <div class="flex flex-row flex-wrap">
                                                    <div v-for="(item2, index2) in sortedCompetitors" :key="index2" class="dashboard-box stats-box w-full px-2 mb-5 mt-3" :class="'lg:w-1/' + search.properties.competitors.list.length">
                                                        <v-card class="pa-2" tile style="border-radius: 5px; background: rgba(68, 70, 143, 0.1); padding: 20px; margin-top: 10px;" :style="((item2.my_business) ? 'background: #ecd3eb;' : '')">
                                                            <div class="p-2 pl-3" style="position: relative;">
                                                                <div style="position: absolute; padding-top: 0px; right: 10px;">

                                                                    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" style="position: absolute;">
                                                                    <rect opacity="0.1" x="0.589844" y="0.5" width="50" height="50" rx="10" fill="#44468F"/>
                                                                    </svg>

                                                                    <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-left: 5px; margin-top: 5px;">
                                                                        <path d="M8.91996 7C7.3599 7 6.08984 8.27097 6.08984 9.83103V27.1933C6.08984 28.7534 7.35996 30.0243 8.91996 30.0243H17.5314L20.1338 35.7081C20.2149 35.8869 20.393 36.0018 20.5894 36.0018C20.7859 36.0018 20.964 35.8869 21.045 35.7081L23.6475 30.0243H32.2578C33.8178 30.0243 35.0888 28.7534 35.0888 27.1933V9.83103C35.0888 8.27097 33.8176 7 32.2578 7H8.91996ZM8.91996 8H32.2577C33.2813 8 34.0887 8.80737 34.0887 9.83103V27.1933C34.0887 28.217 33.2813 29.0234 32.2577 29.0234H23.3262C23.1307 29.0237 22.9535 29.1377 22.8722 29.3154L20.591 34.2977L18.3068 29.3154H18.3066C18.2253 29.1377 18.0481 29.0237 17.8526 29.0234H8.91999C7.89633 29.0234 7.08987 28.217 7.08987 27.1933V9.83103C7.08987 8.80737 7.89633 8 8.91999 8H8.91996ZM20.5565 11.4942H20.5563C20.3552 11.5071 20.1815 11.6397 20.1159 11.8301L18.5349 16.3741L13.7175 16.4737C13.5049 16.4786 13.3188 16.6172 13.2534 16.8192C13.188 17.0212 13.2574 17.2424 13.4266 17.371L17.2635 20.2793L15.8708 24.8846C15.8086 25.0884 15.8822 25.309 16.0545 25.4344C16.2266 25.5599 16.4594 25.5628 16.6344 25.4413L20.5884 22.6913L24.5436 25.4413H24.5438C24.7188 25.5628 24.9516 25.5599 25.1237 25.4344C25.296 25.309 25.3697 25.0884 25.3074 24.8846L23.9118 20.2793L27.7507 17.371C27.9201 17.2422 27.9895 17.0205 27.9235 16.8183C27.8574 16.6161 27.6705 16.4777 27.4578 16.4737L22.6433 16.3741L21.0623 11.8301C20.9886 11.6169 20.7815 11.4792 20.5563 11.4942H20.5565ZM20.5887 13.5167L21.8123 17.0323V17.0321C21.8809 17.2299 22.0657 17.364 22.2751 17.3681L26.0007 17.4433L23.03 19.6913C22.8623 19.8178 22.7918 20.0355 22.8532 20.2364L23.9333 23.798L20.8737 21.6729V21.6727C20.7025 21.5544 20.4757 21.5544 20.3045 21.6727L17.2449 23.7977L18.323 20.2361V20.2364C18.3842 20.0355 18.3132 19.8176 18.1453 19.6913L15.1775 17.4433L18.9031 17.3681C19.1125 17.364 19.2973 17.2299 19.3658 17.0321L20.5887 13.5167Z" fill="#44468F" stroke="#44468F" stroke-width="0.5"/>
                                                                    </svg>
                                                                </div>
                                                                <div class="dashboard-box-title" :style="((item2.my_business) ? 'font-size: 14px; font-weight: bold;' : 'font-size: 12px;')">{{ unEntity(item2.name) }}</div>

                                                                <div class="details-box top-heading">{{ item2.rating_count }} ({{ calculateHowManyMore(item2) }})</div>

                                                                <div class="dashboard-box-title" style="font-size: 12px;">Last Review: {{ ((item2.reviews && item2.reviews.length > 0) ? formatDate(item2.reviews[0].date) : 'never') }}</div>
                                                            </div>
                                                        </v-card>
                                                    </div>
                                                </div>

                                                <div v-for="(item3, index3) in search.properties.summary.items" :key="'agr' + index3">
                                                    <div v-if="item3.title == 'Aggregate Rating'">

                                                        <div style="padding-left: 10px; padding-right: 10px;"><hr /></div>

                                                        <div>
                                                            <div class="float-right pr-2">
                                                                <div class="lsaaudit-badge-container">
                                                                  <!-- Passed Badge -->
                                                                  <span v-if="item3.passed === true" class="lsaaudit-badge lsaaudit-badge-success">
                                                                    <i class="mdi mdi-check-circle-outline"></i>
                                                                    <span>Passed</span>
                                                                  </span>

                                                                  <!-- Needs Work Badge -->
                                                                  <span v-if="item3.passed === false" class="lsaaudit-badge lsaaudit-badge-warning">
                                                                    <i class="mdi mdi-alert-circle-outline"></i>
                                                                    <span>Needs work</span>
                                                                  </span>
                                                                </div>
                                                            </div>

                                                            <div style="padding: 10px;">
                                                                <div style="font-weight: bold; font-size: 16px;">
                                                                    <span v-if="(search.keyword.toLowerCase().indexOf('law') != -1 || search.keyword.toLowerCase().indexOf('attorney') != -1 || search.keyword.toLowerCase().indexOf('real extate') != -1) && item3.title == 'Google Guarantee'">
                                                                        Google Verified
                                                                    </span>
                                                                    <span v-else>
                                                                        {{ item3.title }}
                                                                    </span>
                                                                </div>

                                                                <div v-if="item3.sub_title" style="padding-top: 10px; color: #757B89; font-size: 12px;">
                                                                    <span v-if="(search.keyword.toLowerCase().indexOf('law') != -1 || search.keyword.toLowerCase().indexOf('attorney') != -1 || search.keyword.toLowerCase().indexOf('real extate') != -1) && item3.title == 'Google Guarantee'">
                                                                        {{ item3.sub_title.replace("guaranteed", "Screened") }}
                                                                    </span>
                                                                    <span v-else>
                                                                        {{ item3.sub_title }}
                                                                    </span>
                                                                </div>

                                                                <div v-if="item3.sub_sub_title" style="padding-top: 10px; color: #757B89; font-size: 12px;">
                                                                    {{ item3.sub_sub_title }}
                                                                </div>

                                                                <div style="padding-top: 10px; color: #757B89; font-size: 12px;">
                                                                    {{ item3.description }}
                                                                </div>

                                                                <div class="flex flex-row flex-wrap">
                                                                    <div v-for="(item4, index4) in sortedCompetitors" :key="index4" class="dashboard-box stats-box w-full mb-5 px-2 mt-3" :class="'lg:w-1/' + search.properties.competitors.list.length">
                                                                        <v-card class="pa-2" tile style="border-radius: 5px; background: rgba(68, 70, 143, 0.1); padding: 20px; margin-top: 10px;" :style="((item4.my_business) ? 'background: #ecd3eb;' : '')">
                                                                            <div class="p-2 pl-3" style="position: relative;">
                                                                                <div style="position: absolute; padding-top: 0px; right: 10px;">

                                                                                    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" style="position: absolute;">
                                                                                    <rect opacity="0.1" x="0.589844" y="0.5" width="50" height="50" rx="10" fill="#44468F"/>
                                                                                    </svg>

                                                                                    <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-left: 5px; margin-top: 5px;">
                                                                                        <path d="M8.91996 7C7.3599 7 6.08984 8.27097 6.08984 9.83103V27.1933C6.08984 28.7534 7.35996 30.0243 8.91996 30.0243H17.5314L20.1338 35.7081C20.2149 35.8869 20.393 36.0018 20.5894 36.0018C20.7859 36.0018 20.964 35.8869 21.045 35.7081L23.6475 30.0243H32.2578C33.8178 30.0243 35.0888 28.7534 35.0888 27.1933V9.83103C35.0888 8.27097 33.8176 7 32.2578 7H8.91996ZM8.91996 8H32.2577C33.2813 8 34.0887 8.80737 34.0887 9.83103V27.1933C34.0887 28.217 33.2813 29.0234 32.2577 29.0234H23.3262C23.1307 29.0237 22.9535 29.1377 22.8722 29.3154L20.591 34.2977L18.3068 29.3154H18.3066C18.2253 29.1377 18.0481 29.0237 17.8526 29.0234H8.91999C7.89633 29.0234 7.08987 28.217 7.08987 27.1933V9.83103C7.08987 8.80737 7.89633 8 8.91999 8H8.91996ZM20.5565 11.4942H20.5563C20.3552 11.5071 20.1815 11.6397 20.1159 11.8301L18.5349 16.3741L13.7175 16.4737C13.5049 16.4786 13.3188 16.6172 13.2534 16.8192C13.188 17.0212 13.2574 17.2424 13.4266 17.371L17.2635 20.2793L15.8708 24.8846C15.8086 25.0884 15.8822 25.309 16.0545 25.4344C16.2266 25.5599 16.4594 25.5628 16.6344 25.4413L20.5884 22.6913L24.5436 25.4413H24.5438C24.7188 25.5628 24.9516 25.5599 25.1237 25.4344C25.296 25.309 25.3697 25.0884 25.3074 24.8846L23.9118 20.2793L27.7507 17.371C27.9201 17.2422 27.9895 17.0205 27.9235 16.8183C27.8574 16.6161 27.6705 16.4777 27.4578 16.4737L22.6433 16.3741L21.0623 11.8301C20.9886 11.6169 20.7815 11.4792 20.5563 11.4942H20.5565ZM20.5887 13.5167L21.8123 17.0323V17.0321C21.8809 17.2299 22.0657 17.364 22.2751 17.3681L26.0007 17.4433L23.03 19.6913C22.8623 19.8178 22.7918 20.0355 22.8532 20.2364L23.9333 23.798L20.8737 21.6729V21.6727C20.7025 21.5544 20.4757 21.5544 20.3045 21.6727L17.2449 23.7977L18.323 20.2361V20.2364C18.3842 20.0355 18.3132 19.8176 18.1453 19.6913L15.1775 17.4433L18.9031 17.3681C19.1125 17.364 19.2973 17.2299 19.3658 17.0321L20.5887 13.5167Z" fill="#44468F" stroke="#44468F" stroke-width="0.5"/>
                                                                                    </svg>
                                                                                </div>
                                                                                <div class="dashboard-box-title" :style="((item4.my_business) ? 'font-size: 14px; font-weight: bold;' : 'font-size: 12px;')">{{ unEntity(item4.name) }}</div>

                                                                                <div class="details-box top-heading">{{ item4.rating }}</div>
                                                                            </div>
                                                                        </v-card>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div style="clear: both;"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </v-card>
                                    </div>

                                    <div v-if="item.title == 'Aggregate Rating'" class="-mt-4">
                                        <div class="flex flex-row flex-wrap -mt-4">
                                            <div class="dashboard-box stats-box w-full px-2 mb-5 mt-3 lg:w-1/2">
                                                <v-card class="pa-2" tile>
                                                    <div class="p-2 pl-3" style="position: relative;">
                                                        <div style="font-weight: bold; font-size: 16px;">Your Reviews</div>
                                                        <div v-html="reviews_html" style="padding-top: 10px; color: #757B89; font-size: 12px; max-height: 500px; overflow: auto;"></div>
                                                    </div>
                                                </v-card>
                                            </div>

                                            <div class="dashboard-box stats-box w-full px-2 mb-5 mt-3 lg:w-1/2">
                                                <v-card class="pa-2" tile>
                                                    <div class="p-2 pl-3" style="position: relative;">
                                                        <div style="font-weight: bold; font-size: 16px;">Competitor Reviews</div>
                                                        <div v-html="reviews_html_competitors" style="padding-top: 10px; color: #757B89; font-size: 12px; max-height: 500px; overflow: auto;"></div>
                                                    </div>
                                                </v-card>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div style="clear: both;"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="pt-3">
                    <v-skeleton-loader type="article, article, article, article, article, article, article"></v-skeleton-loader>
                </div>
            </div>
        </div>

        <div v-show="(lsa_tab == 2 || $vuetify.breakpoint.xs || true) && search.widget_id != 490" class="pt-4">
            <div v-if="search.properties.competitors_visibility.list.length > 0 && search.properties.searches.list.length > 0">
                
                <!-- Competitor Visibility Card -->
                <div class="flex flex-row flex-wrap">
                <div class="w-full" style="position: relative;">
                    <div class="dashboard-box stats-box w-full px-2 mb-5">
                    <v-card class="pa-4 pt-6 pb-6" tile>
                        <div style="font-weight: bold; font-size: 16px;">Competitor Visibility</div>

                        <div v-for="(item, index) in search.properties.competitors_visibility.list" :key="index" class="mt-1 mb-1">
                        <div style="float: left; width: 350px; color: #757B89; font-size: 14px; padding-top: 14px;">
                            {{ unEntity(item.name) }}
                        </div>
                        <div style="float: left; border-top: solid 1px #EFEFEF; width: calc(100% - 410px); padding-top: 14px;">
                            <div style="background: #44468F; height: 10px;" :style="'width: ' + item.visibility + ';'"></div>
                        </div>
                        <div style="float: left; border-top: solid 1px #EFEFEF; width: 60px; text-align: right; font-size: 12px; padding-left: 5px; padding-top: 14px;">
                            {{ item.visibility }}%
                        </div>
                        <div style="clear: both;"></div>
                        </div>
                    </v-card>
                    </div>
                </div>
                </div>

                <!-- NEW: Rankings & Performance Section -->
                <div class="flex flex-row flex-wrap">
                <div class="w-full" style="position: relative;">
                    <div class="dashboard-box stats-box w-full px-2 mb-5">
                    <v-card class="pa-6" tile>
  <!-- Section Header -->
  <div class="d-flex align-center justify-space-between mb-6 flex-wrap">
    <div>
      <h3 class="text-h6 font-weight-bold grey--text text--darken-3 mb-1">
        Rankings & Visibility Overview
      </h3>
      <p class="text-caption grey--text mb-0">
        Tracking local search position performance over weekly audits
      </p>
    </div>
    <v-chip :color="healthStatus.color" text-color="white" medium class="font-weight-bold px-4">
      <v-icon left small>{{ healthStatus.icon }}</v-icon>
      {{ healthStatus.text }}
    </v-chip>
  </div>

  <!-- KPI Metric Cards -->
  <v-row class="mb-4">
    <v-col cols="12" sm="6" md="3">
      <v-card outlined class="pa-4 rounded-lg fill-height light-green lighten-5 border-success">
        <div class="text-caption grey--text text--darken-2 font-weight-bold uppercase">Best Rank</div>
        <div class="d-flex align-center mt-1">
          <span class="text-h4 font-weight-black success--text">
            {{ rankingStats.bestRank !== null ? '#' + rankingStats.bestRank : 'N/A' }}
          </span>
        </div>
        <div class="text-caption grey--text mt-1">
          {{ rankingStats.bestDate ? formatDate(rankingStats.bestDate, "MMM DD, YYYY") : 'No Data' }}
        </div>
      </v-card>
    </v-col>

    <v-col cols="12" sm="6" md="3">
      <v-card outlined class="pa-4 rounded-lg fill-height red lighten-5 border-error">
        <div class="text-caption grey--text text--darken-2 font-weight-bold uppercase">Lowest Rank</div>
        <div class="d-flex align-center mt-1">
          <span class="text-h4 font-weight-black error--text">
            {{ rankingStats.worstRank !== null ? '#' + rankingStats.worstRank : 'N/A' }}
          </span>
        </div>
        <div class="text-caption grey--text mt-1">
          {{ rankingStats.worstDate ? formatDate(rankingStats.worstDate, "MMM DD, YYYY") : 'No Data' }}
        </div>
      </v-card>
    </v-col>

    <v-col cols="12" sm="6" md="3">
      <v-card outlined class="pa-4 rounded-lg fill-height blue-grey lighten-5">
        <div class="text-caption grey--text text--darken-2 font-weight-bold uppercase">Average Position</div>
        <div class="d-flex align-center mt-1">
          <span class="text-h4 font-weight-black blue-grey--text text--darken-3">
            {{ rankingStats.avgRank !== null ? '#' + rankingStats.avgRank : 'N/A' }}
          </span>
        </div>
        <div class="text-caption grey--text mt-1">Across all recorded searches</div>
      </v-card>
    </v-col>

    <v-col cols="12" sm="6" md="3">
      <v-card outlined class="pa-4 rounded-lg fill-height" :class="trendConfig.bgColor">
        <div class="text-caption grey--text text--darken-2 font-weight-bold uppercase">Overall Trend</div>
        <div class="d-flex align-center mt-1">
          <v-icon large :color="trendConfig.color" class="mr-2">{{ trendConfig.icon }}</v-icon>
          <span class="text-h5 font-weight-black" :class="trendConfig.textColor">
            {{ trendConfig.label }}
          </span>
        </div>
        <div class="text-caption grey--text mt-1">
          {{ trendConfig.subtext }}
        </div>
      </v-card>
    </v-col>
  </v-row>

  <!-- Trend Area Chart -->
  <div class="mt-6 mb-8">
    <div class="d-flex justify-space-between align-center mb-2">
      <span class="text-subtitle-2 font-weight-bold grey--text text--darken-2">
        Position Trend Line (Rank 1 is Top)
      </span>
    </div>
    <div id="chart">
      <apexchart type="area" height="280" :options="chartOptionsComputed" :series="rankingChartSeries"></apexchart>
    </div>
  </div>

  <v-divider class="my-6"></v-divider>

  <!-- Audit History Table -->
  <div class="text-subtitle-2 font-weight-bold grey--text text--darken-2 mb-3">
    Audit History Logs
  </div>

  <div v-if="processedSearches.length > 0" style="width: 100%; overflow-x: auto;">
    <table class="w-full rg-datatable">
      <thead>
        <tr class="text-left border-b border-gray-200">
          <th class="pb-3 text-caption font-weight-bold grey--text">TIMESTAMP</th>
          <th class="pb-3 text-caption font-weight-bold grey--text">RANK POSITION</th>
          <th class="pb-3 text-caption font-weight-bold grey--text">CHANGE</th>
          <th class="pb-3 text-caption font-weight-bold grey--text">MY BUSINESS VISIBLE</th>
          <th class="pb-3 text-caption font-weight-bold grey--text">RESULTS FOUND</th>
          <th class="pb-3 text-caption font-weight-bold grey--text text-right">ACTIONS</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="lastSearchProcessed" class="border-b border-gray-100 font-weight-medium">
          <td class="py-3">
            {{ formatDate(lastSearchProcessed.timestamp, "MMM DD, YYYY hh:mm A") }}
            <span class="text-caption grey--text">({{ search.properties.run_at_timezone || "PST" }})</span>
          </td>
          <td class="py-3">
            <v-chip small :color="getRankChipColor(lastSearchProcessed.rank)" text-color="white" class="font-weight-bold">
              {{ lastSearchProcessed.rank ? '#' + lastSearchProcessed.rank : 'Unranked' }}
            </v-chip>
          </td>
          <td class="py-3">
            <span :class="lastSearchProcessed.changeColor" class="font-weight-bold text-caption">
              <i :class="lastSearchProcessed.changeIcon"></i> {{ lastSearchProcessed.changeText }}
            </span>
          </td>
          <td class="py-3">
            <v-icon small :color="lastSearchProcessed.has_my_business ? 'success' : 'error'">
              {{ lastSearchProcessed.has_my_business ? 'mdi-check-circle' : 'mdi-close-circle' }}
            </v-icon>
            <span class="ml-1">{{ lastSearchProcessed.has_my_business ? 'Yes' : 'No' }}</span>
          </td>
          <td class="py-3">{{ lastSearchProcessed.results ? lastSearchProcessed.results.length : 0 }}</td>
          <td class="py-3 text-right">
            <v-btn text small color="primary" @click="viewScreenshot(lastSearchProcessed.screenshot)">Screenshot</v-btn>
            <v-btn text small color="primary" @click="viewDetails(lastSearchProcessed)">Details</v-btn>
          </td>
        </tr>

        <tr v-show="showPreviousSearches" v-for="(item, index) in previousSearchesProcessed" :key="index" class="border-b border-gray-100">
          <td class="py-3 text-body-2">
            {{ formatDate(item.timestamp, "MMM DD, YYYY hh:mm A") }}
            <span class="text-caption grey--text">({{ search.properties.run_at_timezone || "PST" }})</span>
          </td>
          <td class="py-3">
            <v-chip small :color="getRankChipColor(item.rank)" text-color="white" class="font-weight-bold">
              {{ item.rank ? '#' + item.rank : 'Unranked' }}
            </v-chip>
          </td>
          <td class="py-3">
            <span :class="item.changeColor" class="font-weight-bold text-caption">
              <i :class="item.changeIcon"></i> {{ item.changeText }}
            </span>
          </td>
          <td class="py-3 text-body-2">
            <v-icon small :color="item.has_my_business ? 'success' : 'error'">
              {{ item.has_my_business ? 'mdi-check-circle' : 'mdi-close-circle' }}
            </v-icon>
            <span class="ml-1">{{ item.has_my_business ? 'Yes' : 'No' }}</span>
          </td>
          <td class="py-3 text-body-2">{{ item.results ? item.results.length : 0 }}</td>
          <td class="py-3 text-right">
            <v-btn text small color="primary" @click="viewScreenshot(item.screenshot)">Screenshot</v-btn>
            <v-btn text small color="primary" @click="viewDetails(item)">Details</v-btn>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="pt-4 text-center" v-if="previousSearchesProcessed.length > 0">
      <v-btn outlined small color="primary" @click="showPreviousSearches = !showPreviousSearches">
        {{ showPreviousSearches ? 'Hide Previous Audits' : 'Show All (' + previousSearchesProcessed.length + ') Previous Audits' }}
      </v-btn>
    </div>
  </div>
</v-card>
                    </div>
                </div>
                </div>

            </div>
            <div v-else class="pt-3">
                <v-skeleton-loader type="article, article, article, article, article, article, article"></v-skeleton-loader>
            </div>
            </div>
    </div>
  </template>
  
  
  <script>
  import axios from 'axios'
  import moment from 'moment'
  import $ from 'jquery'
  
  export default {
    props: ['search'],

    components: {
    },

    data () {
        return {
            faq_keywords: "",
        
            sentiment_data: [],

            lsa_tab: 0,

            loaded: false,

            show_grid: false,

            doChartDo: false,

            showPreviewImage: false,
            
            previewImageUrl: null,

            showDetails: false,

            detailsSearch: null,

            reviews_html: "",
            reviews_html_competitors: "",

            seo_audit_grades: {
                "A+": 100,
                "A": 85,
                "A-": 70,
                "B+": 69,
                "B": 65,
                "B-": 60,
                "C+": 59,
                "C": 55,
                "C-": 50,
                "D+": 49,
                "D": 45,
                "D-": 40,
                "E+": 39,
                "E": 35,
                "E-": 30,
                "F+": 29,
                "F": 20,
                "F-": 10
            },

            shortSummaryDoughnut: {
                series: [0, 0],
                chartOptions: {
                colors:['#3EBB80', '#DCE4DC'],
                plotOptions: {
                    pie: {
                    donut: {
                        size: '55%'
                    }
                    }
                },
                chart: {
                    type: 'donut',
                },
                dataLabels: {
                    enabled: false
                },
                legend: {
                    show: false
                },
                tooltip: {
                    enabled: false
                }
                }
            },

            summaryDoughnut: {
                series: [0, 0],
                chartOptions: {
                colors:['#4EC5A1', '#DCE4DC'],
                plotOptions: {
                    pie: {
                    donut: {
                        size: '55%'
                    }
                    }
                },
                chart: {
                    type: 'donut',
                },
                dataLabels: {
                    enabled: false
                },
                legend: {
                    show: false
                },
                tooltip: {
                    enabled: false
                }
                }
            },

            chartOneOptions: {
              colors: ['#44468F', '#E53F71', '#FFB443', '#19233A'],
              chart: {
                  id: "column-chart",
                  toolbar: {
                      show: false
                  }
              },
              legend: {
                  position: 'top',
                  horizontalAlign: 'right',
                  markers: {
                    width: 8,
                    height: 8,
                    strokeWidth: 0,
                    strokeColor: '#fff',
                    fillColors: undefined,
                    radius: 8,
                    customHTML: undefined,
                    onClick: undefined,
                    offsetX: 0,
                    offsetY: 0
                },
              },
              dataLabels: {
                  enabled: false
              },
              xaxis: {
                  categories: ["August", "September", "October", "November"],
                  labels: {
                    style: {
                      colors: "#757B89"
                    }
                  }
              },
              yaxis: {
                  labels: {
                    style: {
                      colors: "#757B89"
                    }
                  }
              },
              plotOptions: {
                  bar: {
                      columnWidth: "20%", // Adjust the column width to make the bars thinner
                  },
              },
              grid: {
                borderColor: '#0000000d',
                show: true,      // you can either change hear to disable all grids
                xaxis: {
                  lines: {
                    show: false  //or just here to disable only x axis grids
                  }
                },  
                yaxis: {
                  lines: { 
                    show: true,  //or just here to disable only y axis
                    color: '#FF0000'
                  }
                },   
              },
          },
          chartOneSeries: [

              {
                  name: 'Approved Disputes',
                  data: [10, 20, 30, 40], // Custom values for y-axis
              },
              {
                  name: 'Charged Leads',
                  data: [10, 20, 30, 40], // Custom values for y-axis
              },
          ],

            gbpDoughnut: {
                series: [0, 0],
                chartOptions: {
                colors:['#FFB443', '#DCE4DC'],
                plotOptions: {
                    pie: {
                    donut: {
                        size: '55%'
                    }
                    }
                },
                chart: {
                    type: 'donut',
                },
                dataLabels: {
                    enabled: false
                },
                legend: {
                    show: false
                },
                tooltip: {
                    enabled: false
                }
                }
            },

            reviewsDoughnut: {
                series: [0, 0],
                chartOptions: {
                colors:['#3EBB80', '#DCE4DC'],
                plotOptions: {
                    pie: {
                    donut: {
                        size: '55%'
                    }
                    }
                },
                chart: {
                    type: 'donut',
                },
                dataLabels: {
                    enabled: false
                },
                legend: {
                    show: false
                },
                tooltip: {
                    enabled: false
                }
                }
            },

            reviews_options: {
                chart: {
                id: 'vuechart-example',
                toolbar: {
                    show: false
                },
                legend: {
                    show: true
                }
                },
                xaxis: {
                categories: [],
                tickAmount: 10,
                labels: {
                        rotate: 0
                    }
                }
            },
            reviews_series: [],

            reviews_chart_key: 0,

            postsDoughnut: {
                series: [0, 0],
                chartOptions: {
                colors:['#3EBB80', '#DCE4DC'],
                plotOptions: {
                    pie: {
                    donut: {
                        size: '55%'
                    }
                    }
                },
                chart: {
                    type: 'donut',
                },
                dataLabels: {
                    enabled: false
                },
                legend: {
                    show: false
                },
                tooltip: {
                    enabled: false
                }
                }
            },

            posts_options: {
                chart: {
                id: 'vuechart-example',
                toolbar: {
                    show: false
                },
                legend: {
                    show: true
                }
                },
                xaxis: {
                categories: [],
                tickAmount: 10,
                labels: {
                        rotate: 0
                    }
                }
            },
            posts_series: [],

            posts_chart_key: 0,

            my_compet: null,

            reviewsScoreData: null,
            weeksWithReviews: 0,

            lastSearch: null,
            previousSearches: [],
            showPreviousSearches: false,

            // Ranking chart options
            rankingChartOptions: {
                chart: {
                type: 'area',
                height: 280,
                toolbar: { show: false },
                sparkline: { enabled: false }
                },
                colors: ['#44468F'],
                dataLabels: { enabled: true },
                stroke: { curve: 'smooth', width: 3 },
                fill: {
                type: 'gradient',
                gradient: {
                    shadeIntensity: 1,
                    opacityFrom: 0.45,
                    opacityTo: 0.05,
                    stops: [0, 90, 100]
                }
                },
                xaxis: {
                type: 'category',
                categories: [],
                labels: { style: { colors: '#757B89', fontSize: '11px' } }
                },
                yaxis: {
                reversed: true, // Inverted Y-axis so rank #1 stays at top
                min: 1,
                forceNiceScale: true,
                labels: {
                    formatter: (val) => '#' + Math.round(val)
                }
                },
                tooltip: {
                y: {
                    formatter: (val) => val ? '#' + val : 'Unranked'
                }
                }
            }
        }
    },

    computed: {
        // Parses search items, extracts rank, and formats timestamp safely
        processedSearches() {
  const list = (this.search && this.search.properties && this.search.properties.searches && this.search.properties.searches.list) 
    ? this.search.properties.searches.list.slice() 
    : [];

  // Get target business name (e.g. "Champion Pools & Spas, Inc.")
  const targetBizName = (this.search.properties.business.name || '').toLowerCase();
  
  return list.map((item, idx) => {
    let rank = null;

    if (item.results && Array.isArray(item.results)) {
      const foundIdx = item.results.findIndex(r => {
        if (!r.name) return false;
        const resultName = r.name.toLowerCase();
        // Match exact or fuzzy (e.g., "Champion Pools & Spas" inside "Champion Pools & Spas, Inc.")
        return r.my_business === true || 
               resultName === targetBizName || 
               targetBizName.includes(resultName) || 
               resultName.includes(targetBizName.replace(', inc.', '').replace(' inc', '').trim());
      });
      
      if (foundIdx !== -1) {
        // Position property in your JSON starts at 1, or use index + 1
        rank = item.results[foundIdx].position || (foundIdx + 1);
      }
    }

    const timestamp = this.parseTimestamp(item.timestamp || item.created_at || item.date);

    // Calculate position change against previous audit
    let changeText = 'No Change';
    let changeIcon = 'mdi mdi-minus';
    let changeColor = 'grey--text';

    if (idx < list.length - 1) {
      const prevItem = list[idx + 1];
      let prevRank = null;

      if (prevItem.results && Array.isArray(prevItem.results)) {
        const fIdx = prevItem.results.findIndex(r => {
          if (!r.name) return false;
          const resultName = r.name.toLowerCase();
          return r.my_business === true || 
                 resultName === targetBizName || 
                 targetBizName.includes(resultName) || 
                 resultName.includes(targetBizName.replace(', inc.', '').replace(' inc', '').trim());
        });
        if (fIdx !== -1) {
          prevRank = prevItem.results[fIdx].position || (fIdx + 1);
        }
      }

      if (rank && prevRank) {
        const diff = prevRank - rank; // Positive = gained positions (e.g., #2 to #1)
        if (diff > 0) {
          changeText = `+${diff} Pos`;
          changeIcon = 'mdi mdi-arrow-up-bold';
          changeColor = 'green--text text--darken-1';
        } else if (diff < 0) {
          changeText = `${diff} Pos`;
          changeIcon = 'mdi mdi-arrow-down-bold';
          changeColor = 'red--text text--darken-1';
        }
      } else if (rank && !prevRank) {
        changeText = 'New Entry';
        changeIcon = 'mdi mdi-star';
        changeColor = 'green--text text--darken-1';
      }
    }

    return {
      ...item,
      timestamp,
      rank,
      changeText,
      changeIcon,
      changeColor
    };
  });
},

        lastSearchProcessed() {
        return this.processedSearches.length > 0 ? this.processedSearches[0] : null;
        },

        previousSearchesProcessed() {
        return this.processedSearches.slice(1);
        },

        // Generates Best Rank, Lowest Rank, Average Rank, and Dates
        rankingStats() {
        const validRanks = this.processedSearches
            .filter(s => s.rank !== null && s.rank !== undefined)
            .map(s => ({ rank: Number(s.rank), date: s.timestamp }));

        if (validRanks.length === 0) {
            return { bestRank: null, bestDate: null, worstRank: null, worstDate: null, avgRank: null };
        }

        let best = validRanks[0];
        let worst = validRanks[0];
        let sum = 0;

        validRanks.forEach(item => {
            sum += item.rank;
            if (item.rank < best.rank) best = item;
            if (item.rank > worst.rank) worst = item;
        });

        return {
            bestRank: best.rank,
            bestDate: best.date,
            worstRank: worst.rank,
            worstDate: worst.date,
            avgRank: (sum / validRanks.length).toFixed(1)
        };
        },

        // Computes dynamic trend badge state
        trendConfig() {
        const items = this.processedSearches.filter(s => s.rank !== null);
        if (items.length < 2) {
            return {
            label: 'Stable',
            subtext: 'Holding current position',
            icon: 'mdi-minus-circle',
            color: 'blue-grey',
            textColor: 'blue-grey--text',
            bgColor: 'grey lighten-4'
            };
        }

        const newest = items[0].rank;
        const oldest = items[items.length - 1].rank;
        const diff = oldest - newest;

        if (diff > 0) {
            return {
            label: `Up +${diff}`,
            subtext: 'Overall rank improvement',
            icon: 'mdi-trending-up',
            color: 'success',
            textColor: 'success--text',
            bgColor: 'light-green lighten-5'
            };
        } else if (diff < 0) {
            return {
            label: `Down ${diff}`,
            subtext: 'Dropped in search results',
            icon: 'mdi-trending-down',
            color: 'error',
            textColor: 'error--text',
            bgColor: 'red lighten-5'
            };
        } else {
            return {
            label: 'No Change',
            subtext: 'Holding steady position',
            icon: 'mdi-trending-neutral',
            color: 'info',
            textColor: 'info--text',
            bgColor: 'blue lighten-5'
            };
        }
        },

        // Health badge state indicator
        healthStatus() {
        const latest = this.lastSearchProcessed;
        if (!latest || !latest.rank) {
            return { text: 'Not Ranked', color: 'grey', icon: 'mdi-alert-circle-outline' };
        }
        if (latest.rank <= 3) {
            return { text: 'Top Performer', color: '#4CAF50', icon: 'mdi-trophy-outline' };
        } else if (latest.rank <= 10) {
            return { text: 'Good Visibility', color: '#FF9800', icon: 'mdi-chart-line' };
        } else {
            return { text: 'Needs Attention', color: '#E53F71', icon: 'mdi-alert-outline' };
        }
        },

        // Dynamically configures ApexCharts options without racing conditions
        chartOptionsComputed() {
        const chronological = this.processedSearches.slice().reverse();
        const categories = chronological.map(s => this.formatDate(s.timestamp, "MMM DD"));

        return {
            chart: { type: 'area', height: 280, toolbar: { show: false } },
            colors: ['#44468F'],
            dataLabels: { enabled: true },
            stroke: { curve: 'smooth', width: 3 },
            fill: {
            type: 'gradient',
            gradient: { shadeIntensity: 1, opacityFrom: 0.45, opacityTo: 0.05, stops: [0, 90, 100] }
            },
            xaxis: { categories, labels: { style: { colors: '#757B89', fontSize: '11px' } } },
            yaxis: {
            reversed: true, // Reverses scale so #1 is at the top
            min: 1,
            forceNiceScale: true,
            labels: { formatter: (val) => '#' + Math.round(val) }
            },
            tooltip: { y: { formatter: (val) => val ? '#' + val : 'Unranked' } }
        };
        },

        rankingChartSeries() {
        const chronological = this.processedSearches.slice().reverse();
        return [{ name: 'Search Rank', data: chronological.map(s => s.rank) }];
        },
        
        sortedCompetitors() {
            return this.search.properties.competitors.list.slice().sort((a, b) => {
                // If a.my_business is true and b.my_business is false, a comes first (-1)
                if (a.my_business && !b.my_business) return -1;
                // If b.my_business is true and a.my_business is false, b comes first (1)
                if (!a.my_business && b.my_business) return 1;
                // Otherwise keep original order
                return 0;
            });
        },
        
        getFormattedAddress() {
            const biz = this.search.properties.business || {};
            if (biz.address || biz.city || biz.state) {
              return [biz.address, biz.city, biz.state, biz.zip].filter(Boolean).join(', ');
            }
            return biz.formatted_address || 'N/A';
        },

        getFormattedPhone() {
            const biz = this.search.properties.business || {};
            return biz.phone || biz.formatted_phone_number || biz.international_phone_number || 'N/A';
        },

        getBusinessWebsite() {
            const biz = this.search.properties.business || {};
            return biz.website || biz.domain || '';
        },

        getServingArea() {
            const biz = this.search.properties.business || {};
            if (biz.city || biz.state) {
              return [biz.city, biz.state].filter(Boolean).join(', ');
            }
            if (biz.formatted_address && biz.formatted_address.includes(',')) {
              const parts = biz.formatted_address.split(',');
              return parts[1] ? parts[1].trim() : parts[0];
            }
            return 'N/A';
        }
    },

    methods: {
        parseTimestamp(rawDate) {
            if (!rawDate) return new Date();
            
            // Explicitly handle "MMMM DD, YYYY h A" (e.g., "August 03, 2026 10 AM")
            let m = moment(String(rawDate), ["MMMM DD, YYYY h A", "MMMM D, YYYY h A", "YYYY-MM-DD HH:mm:ss"], true);
            if (m.isValid()) return m.toDate();
            
            // Fallback to standard parsing
            let fallback = moment(rawDate);
            return fallback.isValid() ? fallback.toDate() : new Date();
        },

        getRankChipColor(rank) {
            if (!rank) return 'grey';
            if (rank <= 3) return '#4CAF50';
            if (rank <= 10) return '#FF9800';
            return '#757B89';
        },

        calculateHowManyMore(theItem) {
            if (!theItem.reviews)
                return 0;

            const now = new Date();
            const sevenDaysAgo = new Date();
            sevenDaysAgo.setDate(now.getDate() - 7);

            console.log('item', theItem)

            let howMany = 0;

            try {
                let howMany = theItem.reviews.filter(review => {
                    const reviewDate = new Date(review.date);
                    return reviewDate >= sevenDaysAgo && reviewDate <= now;
                }).length;
            }
            catch(e) {}

            if (howMany > 0)
                return "+" + howMany;

            return howMany;
        },

        formatDate(date, format = "MM/DD/YYYY") {
            if (!date) return 'N/A';
            const m = moment(date);
            return m.isValid() ? m.format(format) : 'N/A';
        },
        
        viewScreenshot(screenshot_url) {
            this.showPreviewImage = true;
            this.previewImageUrl = screenshot_url;
        },
        viewDetails(search) {
            this.showDetails = true;
            this.detailsSearch = search;
        },

        ucwords (str) {
            return (str + '').replace(/^([a-z])|\s+([a-z])/g, function ($1) {
                return $1.toUpperCase();
            });
        },
        
        unEntity(str){
            return str.replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">");
        },

        displayCompetitorName(name) {
            return this.unEntity(name);
        },
    
        async runCreated() {
            let self = this

            if (!self.search.properties.success) {
                this.show_grid = true;
            }

            this.loaded = true;

            for (var i in self.search.properties.competitors.list) {
                let competitor = self.search.properties.competitors.list[i];
                if (competitor.my_business) {
                    this.my_compet = competitor;
                }
            }

            if (this.search.properties.summary.grade) {
                this.summaryDoughnut.series = [this.seo_audit_grades[this.search.properties.summary.grade.value], (100 - this.seo_audit_grades[this.search.properties.summary.grade.value])];
            }

            if (this.search.properties.summary.reviews_chart) {
                this.chartOneOptions.xaxis.categories = this.search.properties.summary.reviews_chart.labels;

                this.chartOneSeries = [];
                
                for (var i in this.search.properties.summary.reviews_chart.datasets) {
                    this.chartOneSeries.push({
                        name: i,
                        data: this.search.properties.summary.reviews_chart.datasets[i]
                    })
                }
            }


            let reviewsScoreData = [];

            let reviews_html = "";

            if (this.my_compet && this.my_compet.reviews && this.my_compet.reviews.length == 0) {
                reviews_html = '<div class="pt-2">No reviews found.</div>';
            }
            else {
                for (var i in this.my_compet.reviews) {

                    if (i <= 100 && moment().subtract(56, 'days') <= moment(this.my_compet.reviews[i].date)) {
                        reviewsScoreData.push({
                            date: this.my_compet.reviews[i].date,
                            competitor: false
                        });
                    }

                    let stars_html = '';
        
                    // console.log('review details', this.my_compet.reviews[i])
        
                    for (var j = 0; j < 5; j++) {
                        if (j + 1 <= this.my_compet.reviews[i].rating)
                            stars_html += '<i class="mdi mdi-star" style="color: #FFB443; font-size: 14px; margin-left: 2px;"></i>';
                        else
                            stars_html += '<i class="mdi mdi-star-outline" style="font-size: 14px; margin-left: 2px;"></i>';
                    }
        
                    if (this.my_compet.reviews[i].review.length > 180)
                        this.my_compet.reviews[i].review = this.my_compet.reviews[i].review.substring(0, 180) + '...';

                        // console.log('this.my_compet.reviews[i].date', this.my_compet.reviews[i].date)
        
                    let this_html = '<div style="padding-bottom: 10px; border-bottom: 1px solid rgba(0, 0, 0, 0.05); margin-bottom: 10px;">\
                        <div style=""><strong>' + this.my_compet.reviews[i].name + '</strong> <em style="font-size: 11px;">' +  this.formatDate(this.my_compet.reviews[i].date.replace("0001", "2023").replace("0002", "2023")) + '</em></div>\
                        <div style="padding-top: 5px;">\
                        <strong>' + this.my_compet.reviews[i].rating + '</strong> ' + stars_html + '\
                        </div>\
                        <div style="font-size: 12px; line-height: 20px; padding-top: 5px; color: #757B89;">\
                            ' + this.my_compet.reviews[i].review + '\
                        </div>\
                    </div>';
        
                    reviews_html += this_html;
                }
            }

            this.reviews_html = reviews_html;

            function toBinaryStr(str) {
                const encoder = new TextEncoder();
                // 1: split the UTF-16 string into an array of bytes
                const charCodes = encoder.encode(str);
                // 2: concatenate byte data to create a binary string
                return String.fromCharCode(...charCodes);
            }

            let reviewsForWeeksCalc = reviewsScoreData.map((review) => ({
                review_date: new Date(review.date),
                competitor: !!review.competitor,
            }));

            Date.prototype.getWeek = function () {
                const d = new Date(
                    Date.UTC(this.getFullYear(), this.getMonth(), this.getDate()),
                );
                const dayNum = d.getUTCDay() || 7;
                d.setUTCDate(d.getUTCDate() + 4 - dayNum);
                const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
                return Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
            };

            this.weeksWithReviews = new Set(
                reviewsForWeeksCalc
                .filter((r) => !r.competitor)
                .map((r) => {
                    const date = new Date(r.review_date);
                    return `${date.getFullYear()}-${date.getWeek()}`;
                }),
            ).size;

            this.reviewsScoreData = btoa(toBinaryStr(JSON.stringify(reviewsScoreData)));

            let reviews_html_competitors = "";

           for (var x in this.search.properties.competitors.list) {
                let competitor = this.search.properties.competitors.list[x];
                if (!competitor.my_business) {
                    for (var i in competitor.reviews) {
                        let stars_html = '';
            
                        // console.log('review details', competitor.reviews[i])
            
                        for (var j = 0; j < 5; j++) {
                            if (j + 1 <= competitor.reviews[i].rating)
                                stars_html += '<i class="mdi mdi-star" style="color: #FFB443; font-size: 14px; margin-left: 2px;"></i>';
                            else
                                stars_html += '<i class="mdi mdi-star-outline" style="font-size: 14px; margin-left: 2px;"></i>';
                        }
            
                        if (competitor.reviews[i].review.length > 180)
                            competitor.reviews[i].review = competitor.reviews[i].review.substring(0, 180) + '...';

                            // console.log('competitor.reviews[i].date', competitor.reviews[i].date)
            
                        let this_html = '<div style="padding-bottom: 10px; border-bottom: 1px solid rgba(0, 0, 0, 0.05); margin-bottom: 10px;">\
                            <div style=""><strong>' + competitor.reviews[i].name + '</strong> <em style="font-size: 11px;">' + this.formatDate(competitor.reviews[i].date.replace("0001", "2023").replace("0002", "2023")) + '</em></div>\
                            <div style="padding-top: 5px;">\
                            <strong>' + competitor.reviews[i].rating + '</strong> ' + stars_html + '\
                            </div>\
                            <div style="font-size: 12px; line-height: 20px; padding-top: 5px; color: #757B89;">\
                                ' + competitor.reviews[i].review + '\
                            </div>\
                        </div>';
            
                        reviews_html_competitors += this_html;
                    }
                }
            }

            this.reviews_html_competitors = reviews_html_competitors;

            // this.search.properties.searches.list.reverse();

            // Map dynamic X-Axis categories for the rankings trend chart
            const chronological = this.processedSearches.slice().reverse();
            this.rankingChartOptions = {
                ...this.rankingChartOptions,
                xaxis: {
                categories: chronological.map(s => moment(s.timestamp).format("MMM DD"))
                }
            };

            this.lastSearch = this.search.properties.searches.list[0];

            for (var i in this.search.properties.searches.list) {
                if (i > 0) {
                    this.previousSearches.push(this.search.properties.searches.list[i]);
                }
            }
        },

        doChart() {
            console.log('do chart')
            this.doChartDo = true;
            if (this.search.properties.summary.grade) {
                this.summaryDoughnut.series = [this.seo_audit_grades[this.search.properties.summary.grade.value], (100 - this.seo_audit_grades[this.search.properties.summary.grade.value])];
            }

            if (this.search.properties.summary.reviews_chart) {
                this.chartOneOptions.xaxis.categories = this.search.properties.summary.reviews_chart.labels;
                console.log(this.chartOneOptions.xaxis.categories);

                this.chartOneSeries = [];
                
                for (var i in this.search.properties.summary.reviews_chart.datasets) {
                    this.chartOneSeries.push({
                        name: i,
                        data: this.search.properties.summary.reviews_chart.datasets[i]
                    })
                }
            }
        }
    },
    created() {
        let self = this
        // console.log('search', this.search);

        setTimeout(function() {
            self.runCreated();
        }, 2000);
    }
  }
  </script>

  <style scoped>
.border-success {
  border-left: 4px solid #4CAF50 !important;
}

.border-error {
  border-left: 4px solid #FF5252 !important;
}

.rg-datatable {
  width: 100%;
  border-collapse: collapse;
}

.rg-datatable td, .rg-datatable th {
  padding: 12px 8px;
}

.lsaaudit-badge-container {
  display: flex;
  gap: 12px;
  align-items: center;
}

.lsaaudit-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 20px;
  color: #ffffff;
  font-family: sans-serif;
  font-size: 14px;
  font-weight: 600;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
}

.lsaaudit-badge i {
  font-size: 18px;
  color: #ffffff;
}

.lsaaudit-badge-success {
  background-color: #4CAF50;
}

.lsaaudit-badge-warning {
  background-color: #FF9800;
}
</style>